
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Collection, Feature } from 'ol';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import { Circle, Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';
import { coverageDTO } from '../models/coverageDTO';
import { PerformanceAnalysisDTO } from '../models/performanceAnalysisDTO';
import { PerformanceDTO } from '../models/performanceDTO';
import { EndpointsService } from './endpoints.service';
import { CoordenateService } from './coordenate.service';
import { MapService } from './map.service';
import { ModalControlService } from './modal-control.service';
import { CalculationSettingsModel, ConfigurationModel, ConfigurationRCSModel, RNAVModel } from '../models/configuration';
import { Calculation, CalculationModel, CoverageQuantitativeAssessmentResultModel } from '../models/calculations';
import { ProcedurePerformanceLine } from '../models/procedure-performance-line';
import { SearchService } from './search.service';
import { TopLevelLayers } from '../menu/view-menu/top-level-layers';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ParentLayers } from '../menu/view-menu/parent-layer';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { NavaidModel, NavaidSitingToolModel } from '../models/navaid';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Draw } from 'ol/interaction';
import { NavaidSitingToolComponent } from '../popup/calculations/navaid-siting-tool/navaid-siting-tool.component';
import olMap from 'ol/Map';
import { PointsService } from './points.service';
import { SegmentContinuity } from '../models/SegmentContinuity';
import { ProcedureDTOCalculation, WaypointsDTOCalculation } from '../models/procedure';
import { Chart, Color, InteractionModeFunction, registerables } from 'chart.js';
import { CoverageQuantitativeAssessmentDTO } from '../models/coverageQuantitativeAssessmentDTO';
import { CoverageQuantitativeAssessmentService } from './coverage-quantitative-assessment.service';
import { PerformanceReportDTO } from '../models/performanceReportDTO';
import { Observable, firstValueFrom } from 'rxjs';
import VectorLayer from 'ol/layer/Vector';
import { getRelativePosition } from 'chart.js/helpers';
import { Interaction } from 'chart.js';
import { Coordinate } from 'ol/coordinate';
import * as olProj from 'ol/proj';
import LineString from 'ol/geom/LineString';
import { VicentyToolControlService } from './vicenty-tool-control.service';
import Point from 'ol/geom/Point';
import { FeatureType } from '../models/EnumTypes';
import { DisplayCalculationInfo } from '../models/DisplayCalculationInfo';
import { ConfigurationService } from './configuration.service';
import { cloneDeep } from 'lodash';
import { ProjectService } from './project.service';
import { CrossSectionDTO } from '../models/CrossSectionModel';
import Geometry from 'ol/geom/Geometry';
import { ColorLike } from 'ol/colorlike';
import { ProcedurePerformanceInertialDrift } from '../models/procedurePerformanceInertialDrift';
import { coordinate } from '../models/coordinate';
import { LayerColor, UserSettings, UserSettingsDTO } from '../models/UserSettings';
import { TerrainAltitudeCutDTO } from '../models/TerrainAltitudeCutModel';
import {  UserSettingsService } from './userSettings.service';
import { UtilsService } from './utils.service';
import { TerrainHeightDTO } from '../models/terrainHeightDTO';
import {
  AbstractWorkLogMsg,
  CalcConfigInfo,
  CalcCoverageLog,
  CalcImpactAssessmentLog,
  CalcPerformanceLog,
  CalcProcedurePerfLog,
  CalcSectorizationLog,
  CumulativeCoverageLog,
  NavLocAssessLog,
  TerrainAltitudeCutLog
} from '../models/calcConfigInfo';
import { ToolsControlService } from './tools-control.service';
import { stringify } from 'querystring';
import { UiBlockService } from './ui-block.service';
import {environment} from "../../environments/environment";
import * as pako from 'pako';
import { UserSpaceExceeded, UserSpaceLimitWarningMessage } from '../models/error';

Chart.register(...registerables);

declare module 'chart.js' {
  interface InteractionModeMap {
    myCustomModeVerticalProfile: InteractionModeFunction;
    myCustomModeCreatePlotChart: InteractionModeFunction;
    myCustomModeCreateBarChart: InteractionModeFunction;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CalculationsService {
  cancelCalculation(calculationId: string) {
    // Uses the cancelCalculation endpoint from EndpointsService
    return this.http.post(
      `${this.endpointsService.cancelCalculation}/${calculationId}`,
      null,
      this.endpointsService.httpOptions
    );
  }

  draw: Draw;
  map: olMap;
  colorMap = new Map();
  procedureSources = {};
  activeRCS: ConfigurationRCSModel;
  calculationsLayers: ParentLayers;
  canvas_chart1: HTMLCanvasElement;
  canvas_chart2: HTMLCanvasElement;
  canvas_chart3: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  chart1: Chart;
  chartWorstInertial : Chart;
  chartCenterInertial : Chart;

  displayWorstInertialChart : boolean = false;
  displayCenterInertialChart : boolean = false;

  chart2: Chart;
  chart3: Chart;
  chartPlugins = [{
    id: 'draw_waypoints_plugin',
    afterDraw: chart => {
      let ctx = chart.ctx;
      ctx.save();
      const waypointsDataset = chart.data.datasets.find(dataset => dataset.label == "wayPoints");
      //ctx.textAlign = 'center';
      ctx.font = '12px Arial';
      ctx.fillStyle = 'grey';
      ctx.textAlign = 'left';
      let yPosition = chart.scales.y.top  + chart.scales.y.height / 3;
      if (chart.config.type  != 'bar'){
        yPosition = chart.scales.y.getPixelForValue(chart.scales.y.max) + chart.scales.y.paddingTop;
      }
      waypointsDataset.data.forEach(waypoint => {
        ctx.fillText((waypoint as any).wayPointId, chart.scales.x.getPixelForValue((waypoint as any).x),yPosition);
      });
      ctx.restore();}

  },];
  procedurePerformanceLines: Array<ProcedurePerformanceLine> = [];
  procedureSegmentContinuity: SegmentContinuity = new SegmentContinuity();
  redundancyPercentage: JSON;
  redundancyPercentageTable2: JSON;
  procedureCalculationType: number = 1;
  procedureChartType: string = '';

  displayCalculation : DisplayCalculationInfo = new DisplayCalculationInfo();

  public procedureAnalysisResultActive: boolean = false;
  public fullScreenMode : boolean = false;
  public procedurePerformanceFeatures: Map<number, Array<Feature>> = new Map<number, Array<Feature>>();

  public calcConfigInfoActive: boolean;
  public calcInfo: AbstractWorkLogMsg = undefined;
  public calcInfoDTO: any;
  public calculationInfoIsString:boolean;
  public calcInfoString:String;
  constructor(
    private http: HttpClient,
    private mapService: MapService,
    private endpointsService: EndpointsService,
    private modalService: ModalControlService,
    private modalConfirmation: ModalConfirmationService,
    private rcsControl: CoordenateService,
    private searchService: SearchService,
    private pointsService: PointsService,
    private popupService: BsModalService,
    public cqaController : CoverageQuantitativeAssessmentService,
    private vicentyTool: VicentyToolControlService,
    private configurationService : ConfigurationService,
    public projectController : ProjectService,
    public userSettingsService: UserSettingsService,
    public utilsService: UtilsService,
    private toolsService: ToolsControlService,
    private uiBlock : UiBlockService
  ) {}

  async initializeCalculationService(cumulativeCoverageColors: any[]){
    this.map = this.mapService.getMap('map');
    this.colorMap.set('Redundancy', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //1
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //2
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
    ]);
    this.colorMap.set('Signal Delay', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //1
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //2
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
    ])
    this.colorMap.set('Subtended Angles', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(245, 214, 206,0.5)', //1
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //2
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
      new Fill({
        color: 'rgba(217, 103, 218,0.5)', //5
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //6
      }),
    ]);

    this.colorMap.set('NSE', [
      new Fill({
        color: 'rgba(0, 255, 0,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(80, 255, 80,0.5)', //1
      }),
      new Fill({
        color: 'rgba(130, 255, 130,0.5)', //2
      }),
      new Fill({
        color: 'rgba(200, 255, 200,0.5)', //3
      }),
      new Fill({
        color: 'rgba(255, 200, 200,0.5)', //4
      }),
      new Fill({
        color: 'rgba(255, 130, 130,0.5)', //5
      }),
      new Fill({
        color: 'rgba(255, 80, 80,0.5)', //6
      }),
      new Fill({
        color: 'rgba(255, 0, 0,0.5)', //7
      }),
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //8
      }),
    ]);

    this.colorMap.set('INERTIAL_DRIFT', [
      'rgba(255, 0, 0,1)', //0 -  first index of array
      'rgba(0, 0, 255,1)', //1
      'rgba(0, 255, 0,1)', //2
    ]);


    this.colorMap.set('Available Pairs', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //1
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //2
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
    ]);
    let cumulativeCoverageFills: Fill[] = []
    this.colorMap.set('Cumulative Coverage',cumulativeCoverageColors.forEach(
      (color:LayerColor) =>
      cumulativeCoverageFills.push(new Fill({color: color.color})))
    )

    this.colorMap.set('Cumulative Coverage',cumulativeCoverageFills);

    this.colorMap.set('Coverage', [
      new Stroke({
        color: 'rgba(0, 0, 255, 1)', //0 -  first index of array
      }),
      new Stroke({
        color: 'rgba(0, 0, 255, 0.8)', //1 -  first index of array
      }),
      new Stroke({
        color: 'rgba(0, 0, 255, 0.6)', //2
      }),
      new Stroke({
        color: 'rgba(0, 0, 255, 0.4)', //3
      }),
      new Stroke({
        color: 'rgba(0, 0, 255, 0.2)', //4
      }),
      new Stroke({
        color: 'rgba(0, 0, 255, 0)', //5
      })
    ]);

    this.colorMap.set('Overlap', [
      [0,0,255],
      [0,255,255],
      [0,255,0],
      [255,255,0],
      [255,0,0]
    ]);

    this.colorMap.set('Navaid Location Assessment', {
      fill_VIS_LP_VOR_DME: new Fill({ // VIS_LP_VOR/DME
        color: 'rgba(0, 0, 255, 0.5)',
      }),

      fill_DMR_LP_DME: new Fill({ // DMR_LP_DME
        color: 'rgba(0, 170, 85, 0.5)',
      }),

      fill_DAR_LP_DME: new Fill({ // DAR_LP_DME
        color: 'rgba(0, 0, 255, 0.2)',
      }),

      fill_AREA_OF_INTEREST: new Fill({ // Area of Interest
        color: 'rgba(255, 255, 0, 0.5)',
      })
    });
  }
  openFooter(){
    this.procedureAnalysisResultActive = true;
  }
  closeFooter(){
    this.procedureAnalysisResultActive = false;
    this.pointsService.procedureGraphLayer.childLayers[0].layers
          .find((element) => element.id === 'Procedure_Graph_Layer')
          .olLayer.getSource().clear();
  }
  getCalculationsLayer(): ParentLayers {
    return this.calculationsLayers;
  }

  setCalculationsLayer(calculationsLayers: ParentLayers) {
    this.calculationsLayers = calculationsLayers;
  }

  calculateCoverage(coverageDTO: coverageDTO, showMessage: boolean = true) {
    let name = coverageDTO.name;
    coverageDTO.projectId = this.projectController.activeProject.id;
    this.http
      .post(
        this.endpointsService.coverageUrl,
        coverageDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
      );
    return new Array<string>();
  }

  calculateCumulativeCoverage(coverageDTO: coverageDTO) {
    coverageDTO.projectId = this.projectController.activeProject.id;
    this.http
      .post(
        this.endpointsService.cumulativeUrl,
        coverageDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
      );
    return new Array<string>();
  }

  calculateOverlap(coverageDTO: coverageDTO) {
    coverageDTO.projectId = this.projectController.activeProject.id;
    this.http
      .post(
        this.endpointsService.overlapUrl,
        coverageDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
      );

    return new Array<string>();
  }

  calculatePerformance(performanceDTO: PerformanceDTO, showMessage: boolean = true) {
    performanceDTO.calculationSettings.geometricConstraints = true;
    performanceDTO.projectId = this.projectController.activeProject.id;
    this.http
      .post(
        this.endpointsService.performanceUrl,
        performanceDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
      );
    return new Array<string>();
  }


  calculateRoutePerformanceReport(performanceAnalysisDTO: PerformanceAnalysisDTO) {
      this.http
      .post(
        this.endpointsService.routePerformanceReportUrl,
        performanceAnalysisDTO,
        this.endpointsService.httpOptions
        )
        .subscribe(
          {
            error: (error) => this.showError(error)
          }
        );
  }
  generateReport(performanceReportDTO:PerformanceReportDTO){
    this.http.post(
      this.endpointsService.generatePerformanceReportUrl,
      performanceReportDTO,
      this.endpointsService.fileHttpOptions
    ).subscribe(
      (blob:Blob) => {

        const fileName: string = 'report.'+performanceReportDTO.fileType;
        const objectUrl: string = URL.createObjectURL(blob);
        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
      },
      (error) => this.showError(error)
    )
  }
  calculateHorizonToolRings(performanceAnalysisDTO: PerformanceAnalysisDTO): Observable<Object> {
    let results = null;
    results = this.http
      .post(
        this.endpointsService.horizonRingsUrl,
        performanceAnalysisDTO,
        this.endpointsService.httpOptions
      )
    return results;
  }


  calculateCoverageQuantitativeAssessment(coverageQuantitativeAssessment:CoverageQuantitativeAssessmentDTO) {
    return this.http
      .post(
          this.endpointsService.coverageQuantitativeAssessmentUrl,
        coverageQuantitativeAssessment,
        this.endpointsService.httpOptions
      )
  }

  calculateNavaidSitingTool(navaidSitingToolDTO: NavaidSitingToolModel, showMessage: boolean = true) {
    navaidSitingToolDTO.projectId = this.projectController.activeProject.id;
    this.http
      .post(
        this.endpointsService.sitingToolUrl,
        navaidSitingToolDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
      );
    return new Array<string>();
  }

  showCQAResults(results: CoverageQuantitativeAssessmentResultModel[]) {
    this.cqaController.openWindow();
    this.cqaController.results = results;
  }

  saveCalculations(calculations: CalculationModel[]){
    this.http.post<void>(
      this.endpointsService.saveCalculations,
      calculations,
      this.endpointsService.httpOptions
    ).subscribe( () => {
      this.getPreviousCalculations();
    })
  }

  getPreviousCalculationsHttpRequest(projectId?: number, disableCaching: boolean = false){
    if (!projectId){
      projectId = this.projectController.activeProject.id;
    }
    return this.http.get<CalculationModel[]>(
      this.endpointsService.previousCalculations + '/' + projectId,
      {
        headers : this.endpointsService.httpOptions.headers,
        params : {
          "disableCaching" : disableCaching,
        }
      }
    );
  }

  getPreviousPartialCalculationsHttpRequest(extent: [number, number, number, number], projectId?: number, disableCaching: boolean = false){
    if (!projectId){
      projectId = this.projectController.activeProject.id;
    }
    const params: any = {
      disableCaching: disableCaching
    };

    if (extent && extent.length === 4) {
      params.minX = extent[0].toString();
      params.minY = extent[1].toString();
      params.maxX = extent[2].toString();
      params.maxY = extent[3].toString();
    }
    return this.http.get<CalculationModel[]>(
      this.endpointsService.previousPartialCalculations + '/' + projectId,
      {
        headers : this.endpointsService.httpOptions.headers,
        params : params
      }
    );
  }

  async deleteCalculationsCache(){
    return await firstValueFrom(this.http.delete(
      this.endpointsService.deleteCalculationsCache,
      this.endpointsService.httpOptions
    ));
  }

  getPreviousCalculations() {
    this.uiBlock.startBlock("Adding calculations to map...");
    const result = this.getPreviousCalculationsHttpRequest();
    result.subscribe((calculations) =>{
      this.addCalculationsToMap(calculations);
      this.uiBlock.stopBlock();
    });
  }

  addCalculationsToMap(calculations: CalculationModel[]){
    calculations.forEach(calculation => {
      try {
        if (calculation.calcType == "VERTICAL_PROFILE"){
          return; // continue
        }
        // Check if calculation is already on the map
        const alreadyOnMap = this.getCalculationsLayer().childLayers.some(
          (layer) => layer.calcID === calculation.id
        );
        if (alreadyOnMap) {
          return; // Skip if already present
        }
        this.addCalculationToMap(calculation);
        const calculationVisibilityExists = this.userSettingsService.userSettings.calculationsVisibility.findIndex(cv => cv.id == calculation.id) != -1;
        if (!calculationVisibilityExists){
          let index = this
              .getCalculationsLayer()
              .childLayers.findIndex((x) => x.calcID == calculation.id);
          this.storeVisibilityCalculationInUserSettings(this.getCalculationsLayer().childLayers[index]);
        }
        this.adjustCalculationVisibilityByUserSettings(calculation);
      } catch (e){
        console.error(e);
        return; // continue
      }
    })
  }

  public static decompressCalculationResult(calculation: CalculationModel){
    for (let i = 0; i< calculation.results.length; i++){
      calculation.results[i].result = this.decompressResult(UtilsService.convertBase64ToUint8Array(calculation.results[i].compressedResult));
      calculation.results[i].compressedResult = null // free memory
    }
  }

  addCalculationToMap(calculation: CalculationModel, decompress: boolean = true) {
    if (decompress && calculation.results && calculation.results.length > 0){
      CalculationsService.decompressCalculationResult(calculation);
    }
    switch (calculation.calcType) {
      case 'IMPACT_ASSESSMENT':
        this.showGeoJSONGrit(
          JSON.parse(calculation.results[0].result),
          false,
          calculation.calcName,
          calculation.id
        );
        break;
      case 'COVERAGE': {
        this.showGeoJSON(
          JSON.parse(calculation.results[0].result),
          false,
          calculation.calcName,
          calculation.id
        );
        break;
      }
      case 'PERFORMANCE': {
        let performanceDTO: PerformanceDTO = new PerformanceDTO();
        performanceDTO.isNSE = calculation.results[0].isNse;
        performanceDTO.isAvailablePairs = calculation.results[0].isAvailablePairs;
        performanceDTO.isRedundancy = calculation.results[0].isRedundancy;
        performanceDTO.isSubtendedAngles = calculation.results[0].isSubtendedAngles;
        this.showGeoJSONMultiple(
          JSON.parse(calculation.results[0].result),
          false,
          "Performance: " + calculation.calcName,
          calculation.id,
          performanceDTO
        );
        break;
      }
      case 'PROCEDURE_ANALYSIS': {
        let featureResults = [];
        calculation.results.forEach(resultItem => {
          featureResults.push(resultItem.result);
        });
        this.showGeoJSONPerformanceAnalysis(
          featureResults,
          false,
          false,
          true,
          calculation.calcName,
          calculation.id
        );
        break;
      }
      case 'DOC_SECTORIZATION_DISPLAY': {
        this.showGeoJSONDocSectorization(
          calculation,
          false,
          calculation.calcName,
          calculation.id
        );
        break;
      }
      case 'CUMULATIVE_COVERAGE': {
        this.showGeoJSONMultiple(
          JSON.parse(calculation.results[0].result),
          false,
          "Cumulative Coverage: " + calculation.calcName,
          calculation.id,
          null
        );
        break;
      }
      case "OVERLAP": {
        this.showGeoJSONOverlap(
          JSON.parse(calculation.results[0].result),
          false,
          "Co-Channel Overlap: " + calculation.calcName,
          calculation.id,
          null
        );
        break;
      }
      case 'NAVAID_SITING_TOOL': {
        this.showGeoJSONMultipleNavaidSitingTool(
          JSON.parse(calculation.results[0].result),
          false,
          calculation.calcName + ": NavAid Siting",
          calculation.id
        );
        break;
      }
      case 'TERRAIN_ALTITUDE_CUT': {
        this.showGeoJSONTerrainAltitudeCut(
          calculation,
          false,
          calculation.calcName,
          calculation.id,
        );
        break;
      }
    }
  }

  adjustCalculationVisibilityByUserSettings(calculation){
    let calculationUserSettings = this.userSettingsService.userSettings.calculationsVisibility
        .find(elem => elem.id == calculation.id);
    if (calculationUserSettings == null){
      return;
    }
    let topLevelLayer :TopLevelLayers = this.calculationsLayers.childLayers
    .find((layer: TopLevelLayers) => layer.calcID == calculation.id);
    if(calculation.calcType == 'PERFORMANCE' || calculation.calcType == 'PROCEDURE_ANALYSIS'){
      calculationUserSettings.visibleLayers.forEach(visibleLayer =>{
        let subLayer = topLevelLayer?.layers.find(layer =>layer.name == visibleLayer.name)
        if(subLayer != null){
          subLayer.visible = visibleLayer.visible;
          subLayer.olLayer.setVisible(subLayer.visible);
        }
      })
    }
    else if(calculation.calcType == 'DOC_SECTORIZATION_DISPLAY'){
      calculationUserSettings.visibleLayers.forEach(visibleLayer =>{
          let subLayers = topLevelLayer.layers.filter(layer=> layer.navaidid == visibleLayer.name)
          subLayers.forEach(subLayer =>{
            subLayer.visible = visibleLayer.visible;
            subLayer.olLayer.setVisible(subLayer.visible);
          });
        })
    }
    else {
      topLevelLayer.layers[0].visible = calculationUserSettings.visible;
      topLevelLayer.layers[0].olLayer.setVisible(calculationUserSettings.visible);
    }
  }

  storePerformanceVisibility(calcID:number, layers:any){
    let visibilitySubLayers = [];
    for(let layer of  layers){
      visibilitySubLayers.push({name: layer.name, visible: layer.visible});
    }
    this.userSettingsService.userSettings.calculationsVisibility.push({id: calcID, visibleLayers: visibilitySubLayers });
    this.userSettingsService.updateSettings();
  }
  storeVisibilityCalculationInUserSettings(topLevelLayer:TopLevelLayers){
    if(topLevelLayer == undefined){
      return;
    }
    if(topLevelLayer.type == 'PERFORMANCE' || topLevelLayer.type == 'PROCEDURE_ANALYSIS'){
      let visibilitySubLayers = [];
      for(let layer of  topLevelLayer.layers){
        visibilitySubLayers.push({name: layer.name, visible: layer.visible});
      }
      this.userSettingsService.userSettings.calculationsVisibility.push({id: topLevelLayer.calcID, visibleLayers: visibilitySubLayers });
    }
    else if(topLevelLayer.type == 'DocAndSectorizationDisplay'){
      let visibilitySubLayers = [];
      for(let navaidid of  topLevelLayer.navaids_info.keys()){
        visibilitySubLayers.push({name: navaidid, visible: true});
      }
      this.userSettingsService.userSettings.calculationsVisibility.push({id: topLevelLayer.calcID, visibleLayers: visibilitySubLayers });
    }
    else{
      this.userSettingsService.userSettings.calculationsVisibility.push({id: topLevelLayer.calcID,visible: true });
    }
    this.userSettingsService.updateSettings();
  }
  deleteCalculation(calcID: number, showFeedback: boolean = true) {
    if (showFeedback){
      this.uiBlock.startBlock("Delete calculation...");
    }
    this.http
      .post(
        this.endpointsService.deleteCalculation,
        calcID,
        this.endpointsService.httpOptions
      )
      .subscribe(
        (data) =>{
          if (showFeedback){
            this.removeLayers(calcID);
            this.userSettingsService.deleteCalculationSettings(calcID);
            this.uiBlock.stopBlock();
          }

        },
        (error) => {
          if (showFeedback){
            this.showError(error);
            this.uiBlock.stopBlock();
          }
        }
      );
    return new Array<string>();
  }

  deleteBulKCalculation(calcIDs: Array<number>) {
    this.uiBlock.startBlock("Deleting calculations...");
    return this.http
      .post(
        this.endpointsService.deleteBulkCalculation,
        calcIDs,
        this.endpointsService.httpOptions
      )
  }
  removeLayers(calcID: number) {
    let index = this
      .getCalculationsLayer()
      .childLayers.findIndex((x) => x.calcID == calcID);

    if (index == -1){
      return;
    }

    this
      .getCalculationsLayer()
      .childLayers[index].removeFromMap();

    this.getCalculationsLayer().childLayers.splice(index, 1);
  }

  showError(error) {
    if (error && error.status == 409) {
      this.modalService.showMesssageModal(
        'Calculation unsuccessful',
        'An active terrain is being uploaded, you cannot perform calculations. Please wait for it to finish.' +
        ' If this is not the case, please refresh the page.'
      );
    } else if (error && error.status == 504) {
      this.modalService.showMesssageModal(
        'Calculation in background',
        'The calculation is taking a long time to finish and was moved to the backgroud. Check GRIT later for the results.'
      );
    } else if (error && error.status == 507) {
      if (!error.error) {
        this.modalService.showMesssageModal(
          'Calculation unsuccessful',
          `The was an error while performing the calculation. Please confirm all the data and try again.`
        )
      }
      if(error.error == UserSpaceExceeded){
        this.modalService.showMesssageModal('Warning',UserSpaceLimitWarningMessage);
      } else {
        let errorMessages = [];
        error.error.forEach(response => {
          if (!response.success) {
            errorMessages.push(`${response.message} `)
          }
        });
        if (errorMessages) {
          this.modalService.showMultipleMesssagesModal(
            'Calculation unsuccessful',
            errorMessages
          );
        }
      }
    } else {
      this.modalService.showMesssageModal(
        'Calculation unsuccessful',
        'The was an error while performing the calculation. Please confirm all the data and try again.'
      );
    }
    return new Array<string>();
  }

  showGeoJSONMultiple(
    data: any,
    showMessage: boolean,
    calcName: string,
    id: number,
    performanceDTO : PerformanceDTO,
  ) {
    let layers = [];
    let layerName = '';
    let legend_colors_cumulative_coverage: Map<number, string> = new Map();
    let elevation_info: string[] = [];
    let elevation_colors = new Map<string, string>();
    const isPerformance = data.find(map => map.isDMEDME != null);
    let calculationSettings = this.userSettingsService.getCalculationSettings(id);
    if(calculationSettings == null){
      calculationSettings  = this.userSettingsService.createCalculationSettings(id,0.7,true);
    }
    let transparency_sub_layers = calculationSettings.transparency_sub_layers;
    data.forEach((element) => {
      if (element == isPerformance){
        return;
      }
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(element, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
      });

      if (vectorSource.getFeatures().length > 0) {
        let layerId = vectorSource.getFeatures()[0].getProperties()['ID'];
        var fill;
        let isRedundacy = false;
        if (layerId.includes('REDUNDANCY')) {
          isRedundacy = true;
          layerName = 'Redundancy';
        } else if (layerId.includes('NSE')) {
          layerName = 'NSE';
        } else if (layerId.includes('SUBANGLE')) {
          layerName = 'Subtended Angles';
        } else if (layerId.includes('AVAIL')) {
          layerName = 'Available Pairs';
        } else if (layerId.includes('Cumulative')) {
          layerName = "Cumulative Coverage";
          isRedundacy = true;
        } else if (layerId.includes('NavLocAssess')) {
          layerName = 'Cumulative Coverage';
          isRedundacy = true;
        }

        vectorSource.getFeatures().forEach((feat) => {
          let value = feat.getProperties()['VALUE'];
          if(value < 0){
            return;
          }
          fill = cloneDeep(this.colorMap.get(layerName)[value]);
          if(fill == null){
            return;
          }
          if (layerName == "Cumulative Coverage") {
            const transparency = this.userSettingsService.getCalculationSettings(id).transparency;
            this.utilsService.changeFillTransparency(fill,transparency);
            if (!legend_colors_cumulative_coverage.has(value)) {
              legend_colors_cumulative_coverage.set(value,(fill as Fill).getColor().toString());
            }
            feat.set('featureType',FeatureType.CumulativeCoverage);
          }
          else{
            this.utilsService.changeFillTransparency(fill,transparency_sub_layers[layerName]);
          }
          let style = new Style({
            fill: fill
          });

          if (layerName == "Available Pairs") {
            feat.set('featureType',FeatureType.PerformanceAvailablePairs);
            style.setStroke(new Stroke({
              color: 'rgba(0,0,0)'
            }));
          }
          if (elevation_info.indexOf(feat.getProperties()['ELEVATION']) == -1) {
            elevation_info.push(feat.getProperties()['ELEVATION']);
          }
          elevation_info.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
          feat.setStyle(style);


        });

        var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

        var appLayer = new VectorLayerDMTR({
          source: vectorSource,
        });
        appLayer.setVisible(true);

        //this.mapService.getMap('map').addLayer(appLayer);

        if ((layerName == 'NSE' && performanceDTO.isNSE) || (layerName == 'Available Pairs' && performanceDTO.isAvailablePairs)
        || (layerName == 'Redundancy' && performanceDTO.isRedundancy) || (layerName == 'Subtended Angles' && performanceDTO.isSubtendedAngles) ||
        layerName == 'Cumulative Coverage'){
          var layerObject = {
            id: layerName + currentTimeInMilliseconds,
            name: layerName,
            image: '',
            visible: true,
            expanded: false,
            olLayer: appLayer,
            isDMEDME: true
          };
          if (isPerformance){
            layerObject.isDMEDME = isPerformance.isDMEDME;
          }
          layers.push(layerObject);
        }

      }
    });

    if (layers.length == 0){
      this.modalService.showMesssageModal(
        'Calculation unsuccessful',
        'The calculation did not return any feature.'
      );
      this.deleteCalculation(id, false);
      return;
    }

    if (layers.length > 1) {
      layers.forEach( layer => {
        if(layer.name == "Redundancy") {
          layer.visible = true;
        } else {
          layer.visible = false;
        }
      })
    }

    elevation_info.forEach(elm => {

      if (!elevation_colors.has(elm)) {
        elevation_colors.set(elm, "");

      }
    });


    let topLevel: TopLevelLayers = new TopLevelLayers(
      true,
      calcName,
      layers,
      this.mapService.getMap('map'),
      this.modalConfirmation,
      this,
      null,
      id
    );

    if (layerName == 'Cumulative Coverage') {
      topLevel.type = "Cumulative Coverage";
      const sortedKeys = Array.from(legend_colors_cumulative_coverage.keys()).sort((a, b) => a - b);
        topLevel.cumulative_coverage_colors = [];
        for (const key of sortedKeys) {
          topLevel.cumulative_coverage_colors.push(legend_colors_cumulative_coverage.get(key))
    }
    }
    else if (layerName == 'Navaid Location Assessment') {
      topLevel.type = "NavaidSitingTool";
    } else {
      topLevel.type = "PERFORMANCE";
    }
    topLevel.elevation_info = elevation_colors;

    this
      .getCalculationsLayer()
      .childLayers.push(topLevel);

    if (showMessage) {
      this.modalService.showMesssageModal(
        'Calculation successful',
        'The Performance calculations was successful.'
      );
      this.storeVisibilityCalculationInUserSettings(topLevel);
    }
  }


  public changeCumulativeCoverageColors(cumulativeCoverageColors : any[]){

    let newLayerColorFills = [];
    cumulativeCoverageColors.forEach(
    (layercolor:LayerColor) =>
    newLayerColorFills.push(new Fill({color: layercolor.color})))


    this.colorMap.set('Cumulative Coverage', cloneDeep(newLayerColorFills));
      this.getCalculationsLayer().childLayers.filter(topLevel =>topLevel.type == "Cumulative Coverage")
      .forEach((topLevel: TopLevelLayers )=>{
        let legend_colors_cumulative_coverage: Map<number, string> = new Map();
        topLevel.layers[0].olLayer.getSource().getFeatures().forEach((feature:Feature)=>{
          let value = feature.getProperties()['VALUE'];

          let fill = this.colorMap.get("Cumulative Coverage")[value-1];
          if(fill == null){
            return;
          }
          if (!legend_colors_cumulative_coverage.has(value)) {
            legend_colors_cumulative_coverage.set(value,fill.getColor());
          }
          let style = new Style({
            fill: fill
          });

          feature.setStyle(style);
        });
        const sortedKeys = Array.from(legend_colors_cumulative_coverage.keys()).sort((a, b) => a - b);
        topLevel.cumulative_coverage_colors = [];
        for (const key of sortedKeys) {
          topLevel.cumulative_coverage_colors.push(legend_colors_cumulative_coverage.get(key))
        }
      })

  }
  private transformArrayOfNumbersToRBGAString(numbers: number[]){
    return 'rgba(' + numbers[0] + ',' + numbers[1] + ',' + numbers[2] + ',0.5)';
  }

  private showGeoJSONOverlap(
    data: any,
    showMessage: boolean,
    calcName: string,
    id: number,
    performanceDTO : PerformanceDTO
  ) {
    let layers = [];
    let layerName = '';
    let legend_frequencies_color_overlap: Map<string, string[]> = new Map<string, string[]>();
    let elevation_info: string[] = [];
    let elevation_colors = new Map<string, string>();
    const transparency = this.userSettingsService.getCalculationTransparency(id);
    var vectorSource = new VectorSource({
      features: new GeoJSON().readFeatures(data[0], {
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
        dataProjection: 'CRS:84',
      }),
      format: new GeoJSON({
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
        dataProjection: 'CRS:84',
      }),
    });

    if (vectorSource.getFeatures().length > 0) {

      let Valuefrequencies = new Map<number, string[]>();
      let numberOfColors = 0;
      let colorsForOverlap: number[][] = undefined;
      vectorSource.getFeatures().forEach((feat) => {
        const value = feat.getProperties()['VALUE'];
        const freq = feat.getProperties()['FREQUENCY'];
        if (Valuefrequencies.has(value)){
          const frequencies = Valuefrequencies.get(value);
          if (!frequencies.includes(freq)){
            frequencies.push(freq);
            numberOfColors++;
          }
        }else {
          Valuefrequencies.set(value, [freq]);
          numberOfColors++;
        }
      })
      colorsForOverlap = this.getDynamicPallete(numberOfColors);
      Valuefrequencies.clear();
      numberOfColors = 0;
      let ValuefrequenciesColors = new Map<number, Map<string, string>>();
      const featuresToAdd: Feature<Geometry>[] = [];
      vectorSource.getFeatures().forEach((feat) => {
        let value = feat.getProperties()['VALUE'];
        let fill = undefined;
        const freq = feat.getProperties()['FREQUENCY'];
        if (ValuefrequenciesColors.has(value)){
          const frequencies = ValuefrequenciesColors.get(value);
          if (frequencies.has(freq)){
            fill = new Fill({
              color: frequencies.get(freq)
            })
          } else {
            fill = new Fill({
              color: this.transformArrayOfNumbersToRBGAString(colorsForOverlap[numberOfColors])
            })
            frequencies.set(freq, fill.getColor());
            numberOfColors++;
          }

        } else {
          fill = new Fill({
            color: this.transformArrayOfNumbersToRBGAString(colorsForOverlap[numberOfColors])
          })
          const frequenciesColor = new Map<string, string>();
          frequenciesColor.set(freq, fill.getColor());
          ValuefrequenciesColors.set(value, frequenciesColor);
          numberOfColors++;
        }
        if (!legend_frequencies_color_overlap.has(freq)){
          legend_frequencies_color_overlap.set(freq, [fill.getColor()]);
        } else {
          const frequency = legend_frequencies_color_overlap.get(freq);
          if (!frequency.includes(fill.getColor())){
            frequency.push(fill.getColor());
          }
        }
        this.utilsService.changeFillTransparency(fill,transparency);
        let style = new Style({
          fill: fill
        });

        if (elevation_info.indexOf(feat.getProperties()['ELEVATION']) == -1) {
          elevation_info.push(feat.getProperties()['ELEVATION']);
        }
        elevation_info.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
        feat.setStyle(style);

        featuresToAdd.push(feat);
      });

      featuresToAdd.sort((a, b) => (a.get('FREQUENCY') > b.get('FREQUENCY')) ? 1 : ((b.get('FREQUENCY') > a.get('FREQUENCY')) ? -1 : 0));
      let previousFreq = featuresToAdd[0].get("FREQUENCY")
      let featuresArray = [];
      for (const feature of featuresToAdd){
        const freq = feature.get("FREQUENCY");
        if (freq == previousFreq){
          featuresArray.push(feature);
        } else {
          const vectorSourceToAdd = new VectorSource({
            features: featuresArray,
            format: new GeoJSON({
              featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
              dataProjection: 'CRS:84',
            }),
          });
          var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

          var appLayer = new VectorLayerDMTR({
            source: vectorSourceToAdd,
          });
          appLayer.setVisible(true);

          //this.mapService.getMap('map').addLayer(appLayer);

          var layerObject = {
            id: layerName + currentTimeInMilliseconds,
            name: layerName,
            image: '',
            visible: true,
            expanded: false,
            olLayer: appLayer,
            layerFreq: previousFreq
          };
          layers.push(layerObject);

          featuresArray = [feature];
        }
        previousFreq = freq;
      }

      const vectorSourceToAdd = new VectorSource({
        features: featuresArray,
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
      });
      var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

      var appLayer = new VectorLayerDMTR({
        source: vectorSourceToAdd,
      });
      appLayer.setVisible(true);

      //this.mapService.getMap('map').addLayer(appLayer);

      var layerObject = {
        id: layerName + currentTimeInMilliseconds,
        name: layerName,
        image: '',
        visible: true,
        expanded: false,
        olLayer: appLayer,
        layerFreq: previousFreq
      };
      layers.push(layerObject);



      elevation_info.forEach(elm => {

        if (!elevation_colors.has(elm)) {
          elevation_colors.set(elm, "");

        }
      });


      let topLevel: TopLevelLayers = new TopLevelLayers(
        true,
        calcName,
        layers,
        this.mapService.getMap('map'),
        this.modalConfirmation,
        this,
        null,
        id
      );

      topLevel.type = "Overlap";
      topLevel.overlap_frequency_colors = legend_frequencies_color_overlap;
      topLevel.elevation_info = elevation_colors;

      this
        .getCalculationsLayer()
        .childLayers.push(topLevel);

      if (showMessage) {
        this.modalService.showMesssageModal(
          'Calculation successful',
          'The Overlap calculations was successful.'
        );
        this.storeVisibilityCalculationInUserSettings(topLevel);
      }

    } else {
      this.modalService.showMesssageModal(
        'Calculation unsuccessful',
        'The Overlap calculations did not return any results.'
      );
      //this.deleteCalculation(data.id, false); No need to delete calculation. The server does not save if no features.
    }

  }
  private getDynamicPallete(number: number): number[][] {
    const colorsArray: number[][] = [];

    const colors = this.colorMap.get("Overlap");

    const nIncrements: number = number / (colors.length-1);

    const colorsSteps: number[] = [Number(colors[0][0]), Number(colors[0][1]), Number(colors[0][2])];
    for (let i = 0; i < number; i++) {
        const index: number = Math.floor(i/nIncrements);
        const steps = [];
        steps[0] = (Number(colors[index+1][0]) - Number(colors[index][0])) / nIncrements;
        steps[1] = (Number(colors[index+1][1]) - Number(colors[index][1])) / nIncrements;
        steps[2] = (Number(colors[index+1][2]) - Number(colors[index][2])) / nIncrements;

        colorsArray.push([Math.floor(colorsSteps[0]), Math.floor(colorsSteps[1]), Math.floor(colorsSteps[2])]);

        for (let j = 0; j < 3; j++) {
            colorsSteps[j] = colorsSteps[j] + steps[j];
            colorsSteps[j]=colorsSteps[j]>255?255:colorsSteps[j];
            colorsSteps[j]=colorsSteps[j]<0?0:colorsSteps[j];
        }
    }
    return colorsArray;

  }

  showGeoJSONMultipleNavaidSitingTool(
    data: any,
    showMessage: boolean,
    calcName: string,
    id: number
  ) {
    let layers = [];
    let layerName = 'Navaid Location Assessment';
    const transparency = this.userSettingsService.getCalculationTransparency(id);
    data.forEach((element) => {
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(element, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      });
      if (vectorSource.getFeatures().length <= 0) {
        return;
      }
      let navaid_siting_tool_subtitles: Map<string,string> = new Map();
      vectorSource.getFeatures()
      .forEach((feature:Feature) =>{
        const featureElevation:string = feature.getProperties()['ELEVATION'];
        if(featureElevation == 'Area of Interest'){
          navaid_siting_tool_subtitles.set(featureElevation,"");
        }
        else{
          navaid_siting_tool_subtitles.set(featureElevation.substring(0, featureElevation.lastIndexOf("_")),"");
        }
      });
      const keyArray = Array.from(navaid_siting_tool_subtitles.keys());
      keyArray.forEach((key:string,index:number)=>{
        let rgb: number[] = [];
        if (key === 'Area of Interest') {
          rgb = [255,255,0];
        }
        else if(index + 1< navaid_siting_tool_subtitles.size){
          rgb[0] = 0;
          rgb[2] = ((navaid_siting_tool_subtitles.size / 2.0) - index + 1)*255 / (navaid_siting_tool_subtitles.size / 2.0);
          rgb[1] = 255 - rgb[2];
        }
        else{
          rgb[1] = (navaid_siting_tool_subtitles.size - index + 1)*255/(navaid_siting_tool_subtitles.size/2)
          rgb[0] = 255 - rgb[1];
          rgb[2] = 0;
        }
        navaid_siting_tool_subtitles.set(key,`rgba(${rgb[0]},${rgb[1]},${rgb[2]},${transparency})`)
      })

      vectorSource.getFeatures()
      .forEach((feat,index:number,array:Feature<Geometry>[]) => {
        feat.set("elevationFT", element.elevationFT);
        feat.set("visibilityAnalysis", element.visibilityAnalysis);
        var fill;
        var layerId: string = feat.getProperties()['ID'];

        // Set color depends on ELEVARION value
        let elevation: string = feat.getProperties()['ELEVATION'];
        let color: string;
        if (elevation === 'Area of Interest') {
          color = navaid_siting_tool_subtitles.get(elevation);
        }
        else{
          color = navaid_siting_tool_subtitles.get(elevation.substring(0, elevation.lastIndexOf("_")))
        }

        fill = new Fill({color: color});

        //this.utilsService.changeFillTransparency(fill,transparency);
        let style = new Style({
          fill: fill
        });

        feat.setStyle(style);
      })
      var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

      var appLayer = new VectorLayerDMTR({
        source: vectorSource,
      });
      appLayer.setVisible(true);
      let subtitleArray: Legend[] = [];
      keyArray.forEach((key:string)=>{
        subtitleArray.push(new Legend(key,navaid_siting_tool_subtitles.get(key)));
      })
      var layerObject = {
        id: layerName + currentTimeInMilliseconds,
        name: layerName,
        image: '',
        visible: true,
        expanded: false,
        olLayer: appLayer,
        subtitles: cloneDeep(subtitleArray)
      };
      layers.push(layerObject);
    });

    let topLevel: TopLevelLayers = new TopLevelLayers(
      true,
      calcName + " - Navaid Siting Tool",
      layers,
      this.mapService.getMap('map'),
      this.modalConfirmation,
      this,
      null,
      id
    );
    topLevel.type = "NavaidSitingTool";

    this
      .getCalculationsLayer()
      .childLayers.push(topLevel);

    if (showMessage) {
      this.modalService.showMesssageModal(
        'Calculation successful',
        'The Performance calculations was successful.'
      );
      this.storeVisibilityCalculationInUserSettings(topLevel);
      }
  }


  //#region GRIT
  showGeoJSONGrit(
    data: Object,
    showMessage: boolean,
    calcName: string,
    id: number
  ) {

    //Create source
    let source = new VectorSource({
      features:
        new GeoJSON().readFeatures(data, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      format: new GeoJSON({
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        dataProjection: 'CRS:84',
      }),
    });

    //Create Layer and Manipulate features if they exist
    if (source.getFeatures().length > 0) {
      
      const currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

      const appLayer = new VectorLayerDMTR({source: source, declutter: true});
      appLayer.setVisible(true);

      const layers = [
        {
          id: `${currentTimeInMilliseconds}`,
          name: 'Impact Assessment',
          image: '',
          visible: true,
          expanded: false,
          olLayer: appLayer,
          procedure: false
        },
      ];

      const topLayer: TopLevelLayers = new TopLevelLayers(
        true,
        calcName + ' - Impact Assessment',
        layers,
        this.mapService.getMap('map'),
        this.modalConfirmation,
        this,
        null,
        id,
        "Impact Assessment"
      );
      this.getCalculationsLayer().childLayers.push(topLayer);

      
      let orderedFeatures = source
        .getFeatures().sort((a, b) => ((a.get('ELEV') ?? 0) - (b.get('ELEV') ?? 0)));

      //Color settings
      let calc_settings = this.userSettingsService.getCalculationSettings(id);
      if (calc_settings == null){
        let color: string = `rgba(${0}, ${0}, ${255}, ${1})|rgba(${20}, ${130}, ${20}, ${1})`;
        calc_settings = this.userSettingsService.createCalculationSettings(id,1,null,color);
      }

      let color: string = `rgba(${0}, ${0}, ${255}, ${1})|rgba(${20}, ${130}, ${20}, ${1})`;
      //Jamming Color
      let colors = color.split("|");
      let [r_j,g_j,b_j] = this.utilsService.extractRGBAValues(colors[0])
      let [r_s,g_s,b_s] = this.utilsService.extractRGBAValues(colors[1] ?? colors[0])

      //Color for each elevation
      let elevations : string[] = [];
      orderedFeatures.forEach(feature => {
        let elevation : string = String(feature.getProperties()['ELEV']);
        if(!elevations.includes(elevation)) elevations.push(elevation)
      })

      // let colorIncrement: number = Math.round((255 / elevations.length) * 100) / 100;
      // let elevation_colors = new Map<string, string>();
      // elevations.forEach((elevation, index)=> {
      //   let add = /*colorIncrement * index*/ 0;
      //
      //   //Jamming Color
      //   let color: string = `rgba(${r_j + add}, ${g_j + add}, ${b_j}, ${calc_settings.transparency})`;
      //   elevation_colors.set(`${elevation}_J`, color);
      //
      //   //Spoofing Color
      //   let colorc: string = `rgba(${r_s + add}, ${g_s}, ${b_s + add}, ${calc_settings.transparency})`;
      //   elevation_colors.set(`${elevation}_S`, colorc);
      // })

      let elevation_colors = new Map<string, string>();
      //Jamming Color
      let color_j: string = `rgba(${r_j}, ${g_j}, ${b_j}, ${calc_settings.transparency})`;
      elevation_colors.set('Jamming', color_j);

      //Spoofing Color
      let color_s: string = `rgba(${r_s}, ${g_s}, ${b_s}, ${calc_settings.transparency})`;
      elevation_colors.set('Spoofing', color_s);

      //Customize Feature
      orderedFeatures.forEach((feat) => {
        let type = String(feat.getProperties()['ID'])
          .split("_", 1).at(0)
          .split("-")?.at(2) ?? "J";
        let elevation: string = String(feat.getProperties()['ELEV']);

        feat.set("elevationLegendPos", (40 * elevations.indexOf(elevation)).toString());
        feat.set("hasLabel", true);

        const style = function() {
          const zoom = this.map.getView().getZoom();
          let text = (zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT || !feat.get("hasLabel")) ? "" : elevation;

          let color = type == "J" ? "Jamming" : "Spoofing"

          return [
            new Style({
              stroke: new Stroke({color: elevation_colors.get(color)}),
              text: new Text({
                text: text,
                font: 'bold ' + 13 + 'px Calibri,sans-serif',
                offsetY: 0,
                overflow: false,
                fill: new Fill({color: elevation_colors.get(color)}),
              }),
            })
          ];
        }.bind(this);
        feat.setStyle(style);
      });

      topLayer.elevation_info = elevation_colors;

      if (showMessage) {
        this.modalService.showMesssageModal(
          'Calculation successful',
          'The Impact Assessment calculation was successful.'
        );
        this.storeVisibilityCalculationInUserSettings(topLayer);
      }
    } else {
      this.modalService.showMesssageModal(
        'Impact Assessment Results',
        'The performed calculation did not return any result. Please check calculation parameters.'
      );

      this.deleteCalculation(id, false);
  }


  }
  //endregion

  showGeoJSON(
    data: Object,
    showMessage: boolean,
    calcName: string,
    id: number
  ) {

    let elevation_info: string[] = [];
    let elevation_colors = new Map<string, string>();
    var color_split_number;
    var color_opacity_to_subtract;
    var vectorSource = new VectorSource({
      features:
        new GeoJSON().readFeatures(data, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      format: new GeoJSON({
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        dataProjection: 'CRS:84',
      }),
    });
    if (vectorSource.getFeatures().length > 0){
      let toOrderfeatures = vectorSource.getFeatures();
      const collection: Collection<Feature<Geometry>> = new Collection<Feature<Geometry>>();
      toOrderfeatures.sort((a, b) => (a.get('ELEV') > b.get('ELEV')) ? 1 : ((b.get('ELEV') > a.get('ELEV')) ? -1 : 0));
      collection.extend(toOrderfeatures);
      vectorSource = new VectorSource({
        features: collection,
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      })
      let previousElevation = null;
      let elevationLegendPos = 0;
      vectorSource.getFeatures().forEach((feat) => {
        let feature_elevation = feat.getProperties()['ELEV'];
        if (previousElevation != null && previousElevation != feature_elevation){
          elevationLegendPos += 40;
        }
        feat.set("elevationLegendPos", elevationLegendPos.toString());
        if (elevation_info.indexOf(feature_elevation) == -1) {
          elevation_info.push(feature_elevation);
        }
        elevation_info.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
        previousElevation = feature_elevation;
      });

      color_split_number = elevation_info.length;
      color_opacity_to_subtract = Math.round((1 / color_split_number) * 100) / 100;
      let toAdd: number = Math.round((255 / color_split_number) * 100) / 100;
      let calc_settings = this.userSettingsService.getCalculationSettings(id);

      if(calc_settings == null){
        let color: string = `rgba(${0}, ${0}, ${255},${1})`;
        calc_settings = this.userSettingsService.createCalculationSettings(id,1,null,color);
      }
      let [r,g,b] = this.utilsService.extractRGBAValues(calc_settings.color)
      elevation_info.forEach(elm => {

        if (!elevation_colors.has(elm)) {
          let color: string = `rgba(${r}, ${g}, ${b},${calc_settings.transparency})`;
          elevation_colors.set(elm, color);
          //opacity = Math.round((opacity - color_opacity_to_subtract) * 100) / 100;
          b = b;
          g = g + toAdd;
          r = r + toAdd;
        }
      });

      const newVectorSource : VectorSource = new VectorSource();
      const elevationsLabelsAddedToMap: string[] = [];
      for (const feat of vectorSource.getFeatures()) {
        let feature_elevation = feat.getProperties()['ELEV'];
        let feat_id = feat.getProperties()['ID'];
        let feat_ident_elevation = feat_id.substr(0,feat_id.lastIndexOf("_"))
        if (!elevationsLabelsAddedToMap.includes(feat_ident_elevation + "")){
          elevationsLabelsAddedToMap.push(feat_ident_elevation + "");
          feat.set("hasLabel", true);
        }
        const style = function() {
          const zoom = this.map.getView().getZoom();
          let text = feature_elevation + '';
          if (zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT || !feat.get("hasLabel")){
            text = "";
          }
          return [
            new Style({
          stroke: new Stroke({
            color: elevation_colors.get(feature_elevation),
          }),
          text: new Text({
                text: text,
                //scale: font_size,
                font: 'bold ' + 13 + 'px Calibri,sans-serif',
                //offsetX: ratioToAdd,
                offsetY: 0,
                overflow: false,
            fill: new Fill({
              color: elevation_colors.get(feature_elevation)
            }),
          }),
            })
          ];
        }.bind(this);
        feat.setStyle(style);
        newVectorSource.addFeature(feat);
      };

      let currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

      let appLayer = new VectorLayerDMTR({
        source: newVectorSource,
        declutter: true
      });
      appLayer.setVisible(true);

      //this.mapService.getMap('map').addLayer(appLayer);
      let layers = [
        {
          id: '' + currentTimeInMilliseconds,
          name: 'Coverage',
          image: '',
          visible: true,
          expanded: false,
          olLayer: appLayer,
          procedure: false
        },
      ];

      let topLayer: TopLevelLayers = new TopLevelLayers(
        true,
        calcName + ' - Coverage: ' + elevation_info[0] + '-' + elevation_info[elevation_info.length - 1] + ' feet',
        layers,
        this.mapService.getMap('map'),
        this.modalConfirmation,
        this,
        null,
        id
      );
      topLayer.type = "Coverage";
      topLayer.elevation_info = elevation_colors;
      this
        .getCalculationsLayer()
        .childLayers.push(topLayer);

      if (showMessage) {
        this.modalService.showMesssageModal(
          'Calculation successful',
          'The Coverage calculations was successful.'
        );
        this.storeVisibilityCalculationInUserSettings(topLayer);
      }
    } else {
      // this.modalService.showMesssageModal("No Results", "The performed calculation did not return any result.");
    }

  }

  showGeoJSONPerformanceAnalysis(
    data: any,
    openTab: boolean,
    newCalculation: boolean,
    drawOnMap: boolean,
    calcName: string,
    id: number,
    performanceDTO?: PerformanceAnalysisDTO
  ) {
    let procedure_type = "";
    let procedure_aircraftSpeed : number = null;
    let procedure_runwayUpdateValue : number = null;
    let procedure_inertialDrift : number = null;
    let procedure_maxAllowedNSE : number = null;

    let procedure_isInertialDrift : boolean = null;
    let horizontalUnits : string = this.configurationService.currentConfiguration?.display.horizontalUnits;
    if(performanceDTO != null){
      performanceDTO.projectId = this.projectController.activeProject.id;
      this.procedureCalculationType = performanceDTO.performanceType;
    }

    let index = 0;
    let layers: any = [];
    this.procedurePerformanceFeatures.set(id, []);


    data.forEach(result => {
      // TODO: VALIDATE PROCEDURE WITH CURVED LEGS
      let custom_type = JSON.parse(result).custom_type;
      procedure_type = JSON.parse(result).procedure_type != undefined ? JSON.parse(result).procedure_type : procedure_type;
      procedure_aircraftSpeed = JSON.parse(result).procedure_aircraftSpeed != undefined ? +JSON.parse(result).procedure_aircraftSpeed : procedure_aircraftSpeed;
      procedure_runwayUpdateValue = JSON.parse(result).procedure_runwayUpdateValue != undefined ? +JSON.parse(result).procedure_runwayUpdateValue : procedure_runwayUpdateValue;
      procedure_inertialDrift = JSON.parse(result).procedure_inertialDrift != undefined ? +JSON.parse(result).procedure_inertialDrift : procedure_inertialDrift;
      procedure_maxAllowedNSE = JSON.parse(result).procedure_maxAllowedNSE != undefined ? +JSON.parse(result).procedure_maxAllowedNSE : procedure_maxAllowedNSE;
      procedure_isInertialDrift = JSON.parse(result).procedure_isInertialDrift != undefined ? JSON.parse(JSON.parse(result).procedure_isInertialDrift) : procedure_isInertialDrift;

      if (custom_type == "Segment Continuty") {
        if (performanceDTO != undefined) {
          this.createSegmentContinuty(result, performanceDTO.procedure);
        }
        return;
      }
      if (custom_type == "RedundancyPercentage") {
        if (performanceDTO != undefined) {
          this.createRedundancyPercentages(result);
        }
        return;
      }

      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(result, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
      });

      this.procedureSources[calcName] = vectorSource;
      let calculationSettings: any = this.userSettingsService.getCalculationSettings(id);

      if(calculationSettings == null)
        calculationSettings = this.userSettingsService.createCalculationSettings(id,0.7,true)
      let transparency_sub_layers = calculationSettings.transparency_sub_layers


      vectorSource.getFeatures().forEach((feat) => {
        feat['CALC_NAME'] = calcName;
        let value = feat.getProperties()['VALUE'];
        this.procedurePerformanceFeatures.get(id).push(feat);
        let style = this.getFeatureColor(feat, value, custom_type,transparency_sub_layers[custom_type]);
        feat.setStyle(style);
      });
        this.addLayerByType(layers, custom_type, vectorSource);
        index++;
     });
     if(newCalculation){
       this.storePerformanceVisibility(id,layers);
      }
      if(drawOnMap){
        let topLevelLayer:TopLevelLayers = new TopLevelLayers(
        true,
        'Procedure Analysis - ' + calcName,
        layers,
        this.mapService.getMap('map'),
        this.modalConfirmation,
        this,
        null,
        id,
        "PROCEDURE_ANALYSIS"
        );
        this.getCalculationsLayer().childLayers.push(topLevelLayer);
      }
      if (openTab) {
      this.openFooter();
      this.procedureCalculationType = performanceDTO.performanceType;
      this.procedureChartType = performanceDTO.resultanalysis;
      if (performanceDTO.resultanalysis == 'bar') {
        this.updateChart(id, performanceDTO);
      } else {
        this.createPlotChart(id, performanceDTO);
      }

    }


    this.fillProcedureLines(id);
    if(procedure_isInertialDrift){

      let featuresWorst : Feature[] = ProcedurePerformanceInertialDrift.generateInertialDriftLayer(procedure_type,procedure_aircraftSpeed, procedure_runwayUpdateValue, horizontalUnits, this.procedurePerformanceLines,true, this.mapService, this, this.modalConfirmation);
      let featuresCenter : Feature[] = ProcedurePerformanceInertialDrift.generateInertialDriftLayer(procedure_type,procedure_aircraftSpeed, procedure_runwayUpdateValue, horizontalUnits, this.procedurePerformanceLines,false, this.mapService, this, this.modalConfirmation);
      let worstLayer = this.createLayerFromFeatures(featuresWorst, "WorstInertialDrift", "Worst Inertial Drift");
      let centerLayer = this.createLayerFromFeatures(featuresCenter, "CenterInertialDrift", "Center Line Inertial Drift");

      layers.push(worstLayer);
      layers.push(centerLayer);
      ProcedurePerformanceInertialDrift.setMaxNSE(procedure_maxAllowedNSE);
      ProcedurePerformanceInertialDrift.setWorstInertialDrift(procedure_inertialDrift);
      let inertialWorstDataset = ProcedurePerformanceInertialDrift.getInertialValues();
      this.createInertialPlotCharts(inertialWorstDataset, true);
      let inertialCenterDataset = ProcedurePerformanceInertialDrift.getInertialValues();
      this.createInertialPlotCharts(inertialCenterDataset, false);
    }



  }
  private get30SecZoneDataset(id,lineData,color){
    return {
      label: id,
      data: lineData,
      borderColor: color,
      fill:false,
      tension: 0
    }
  }


  private createLayerFromFeatures(features : Feature[], layerId : string, layerName: string) {
    var vectorSource = new VectorSource({
      features: features,
    });

    var appLayer = new VectorLayerDMTR({
      source: vectorSource,
    });

    appLayer.setVisible(true);

    var layerObject = {
      id: layerId,
      name: layerName,
      image: '',
      visible: true,
      expanded: false,
      olLayer: appLayer,
    };

    return layerObject;
  }
  private separateDataSegments(navaidData,distances){
    let horizontalUnits : string = this.configurationService.currentConfiguration.display.horizontalUnits;
    let segments = [];
    let j = 0;
    let segment = [];
    let insideSegment = false;
    for(let i  = 0; i < distances.length; i++){
      if(navaidData[j].distance <= distances[i]){
        segment.push(navaidData[j]);
        insideSegment = true;
        j++;
        if(navaidData[j] == undefined){
          break;
        }
      }
      else{
        if(insideSegment){
          insideSegment = false;
          segments.push(segment);
          segment = [];
        }
      }
    }
    if(insideSegment){
      segments.push(segment);
    }
    return segments;
  }
  private getNavaidChartData(navaidData:any,distances:any){
    let line : any = [];
    let segments = this.separateDataSegments(navaidData,distances);

    for(let i = 0; i < segments.length; i++){

      //left line
      line.push({x: segments[i][0].distance,y: segments[i][0].min});
      line.push({x: segments[i][0].distance,y: segments[i][0].max});
      //top line
      for(let j = 0; j < segments[i].length; j++){
        let distance = segments[i][j].distance;
        line.push({x: distance, y : segments[i][j].max});
      }
      //right line
      line.push({x: segments[i][segments[i].length -1].distance,
        y: segments[i][segments[i].length -1].max});

      line.push({x: segments[i][segments[i].length -1].distance,
         y: segments[i][segments[i].length -1].min});

      //bottom line
      for(let j = 0; j < segments[i].length; j++){
        let distance = segments[i][segments[i].length -1-j].distance;
        line.push({x: distance, y : segments[i][segments[i].length -1-j].min});
      }
      // separator
      //let distance = segments[i][segments[i].length -1].distance;
      line.push({x:NaN, y: NaN });


    }
    return line;
  }

  private calculatePoint(i: number, t:number , radius: number, leg: any): any {
		let calculatedPoint: number[] = VicentyToolControlService.calculateDestinationPoint(leg.fixPoint.startPoint.altitude,
				leg.fixPoint.startPoint.longitude, t, radius);
		let newPoint: any = new Object;
		newPoint.altitude = leg.startPoint.altitude;
		let point: any = new Object;
		point.latitude = calculatedPoint[0];
		point.longitude = calculatedPoint[1];
		point.coordpointid = leg.id + "CP" + i;
		newPoint.coordPoint = point;
		newPoint.isstraightleg = false;
		leg.curvePoints.push(newPoint);
		i++;
		return newPoint;
	}

  private getPointAtDistance(distance: number, leg: any) : Coordinate {
		var toRet: Coordinate = [];
		var totalDistance: number = 0.0;
		if (leg.curvePoints == null || leg.curvePoints.length == 0) {
			leg.curvePoints = this.calculateCurvePoints(leg);
		}

		let previousLat: number = leg.startPoint.coordPoint.latitude;
		let previousLong: number = leg.startPoint.coordPoint.longitude;

		for (let curvePoint of leg.curvePoints) {
			totalDistance += VicentyToolControlService.calculateDistance(previousLat, previousLong, curvePoint.latitude,
        curvePoint.longitude);
			if (totalDistance > distance) {
				toRet[0] = previousLong;
				toRet[1] = previousLat;
				break;
			}

			previousLat = curvePoint.latitude;
			previousLong = curvePoint.longitude;
		}
		return toRet;
	}

  private calculateCurvePoints(leg: any) : any {

		var toReturn = [];

		leg.curvePoints = [];
		var i: number = 0;

		var radius: number = VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude, leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude);
		var startAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude, leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude);
		var endAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude,leg.endPoint.coordPoint.latitude,
      leg.endPoint.coordPoint.longitude);

		var angle: number = startAzimuth - endAzimuth;
		if (angle > 0.0) {
			if (angle > 180.0) {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t + leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			} else {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t - leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			}
		} else {
			angle = Math.abs(angle);
			if (angle > 180.0) {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t - leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			} else {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t + leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			}
		}
		return toReturn;
	}

  calculatePositionOnMap(distance: number, procedurePointsList, rootPointsDistance, procedureLegs) : Coordinate {

    let coordinate: Coordinate = [];
		if (distance <= rootPointsDistance[0]) {
      coordinate[0] = procedurePointsList[0][0];
      coordinate[1] = procedurePointsList[0][1];

      //coordinate = olProj.transform(coordinate, 'EPSG:3857','EPSG:4326');

			return coordinate;

		} else if (distance >= rootPointsDistance[rootPointsDistance.length - 1]) {
      coordinate[0] = procedurePointsList[procedurePointsList.length - 1][0];
      coordinate[1] = procedurePointsList[procedurePointsList.length - 1][1];
      //coordinate = olProj.transform(coordinate, 'EPSG:3857','EPSG:4326');

			return coordinate;

		} else {


			var index: number = 0;
			for (let i = 0; i < rootPointsDistance.length; i++) {
				if (distance > rootPointsDistance[i]) {
					index = i;
				}
			}

			var leg = procedureLegs[index];

			if (leg.isstraightleg) {
				let latitude1: number = procedurePointsList[index][1];
				let longitude1: number = procedurePointsList[index][0];
				let latitude2: number = procedurePointsList[index+1][1];
				let longitude2: number = procedurePointsList[index+1 ][0];

        let coordinateToCalc1 = [longitude1, latitude1];
        let coordinateToCalc2 = [longitude2, latitude2];

        // coordinateToCalc1 = olProj.transform(coordinateToCalc1, 'EPSG:3857','EPSG:4326');
        // coordinateToCalc2 = olProj.transform(coordinateToCalc2, 'EPSG:3857','EPSG:4326');

				let azimuth: number = VicentyToolControlService.calculateAzimuth(coordinateToCalc1[1], coordinateToCalc1[0], coordinateToCalc2[1], coordinateToCalc2[0]);
				let increment: number = distance - rootPointsDistance[index];

			  let result: number[] = VicentyToolControlService.calculateDestinationPoint(coordinateToCalc1[1], coordinateToCalc1[0], azimuth, increment);
        coordinate[0] = result[1];
				coordinate[1] = result[0];

			} else {
				let increment: number = distance - rootPointsDistance[index];
				let points: Coordinate = this.getPointAtDistance(increment, leg);
				coordinate[0] = points[0];
				coordinate[1] = points[1];
			}

			return coordinate;
		}
	}
  getLegsDistance(legs: any[]): number[]{
    let distance: number = 0;
		var rootPointsDistance: number[] = [];
		rootPointsDistance.push(distance);
		for (let i = 0; i < legs.length; i++) {
			let leg = legs[i];
			distance += this.calculateDistance(leg);
			rootPointsDistance.push(distance);
		}
    return rootPointsDistance;
  }

  private calculateDistance(leg: any) : number {
    var distance: number = 0.0;
    if (leg.isstraightleg) {
      distance += VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
        leg.startPoint.coordPoint.longitude, leg.endPoint.coordPoint.latitude,
        leg.endPoint.coordPoint.longitude);
    } else {

      if (leg.curvePoints == null || leg.curvePoints.length == 0) {
        leg.curvePoints = this.calculateCurvePoints(leg);
      }

      var previousLat: number = leg.startPoint.coordPoint.latitude;
      var previousLong: number = leg.startPoint.coordPoint.longitude;

      for (let curvePoint of leg.curvePoints) {
        distance += VicentyToolControlService.calculateDistance(previousLat, previousLong, curvePoint.latitude,
            curvePoint.longitude);
        previousLat = curvePoint.latitude;
        previousLong = curvePoint.longitude;
      }
    }

    return distance;
  }

  getProcedureCoordinates(legs: any[]): any {
    var toRet = [];
    var coord: number[] = [];
    coord.push(legs[0].startPoint.coordPoint.longitude);
    coord.push(legs[0].startPoint.coordPoint.latitude);
    toRet.push(coord);
    for (let leg of legs){
      coord = [];
      coord.push(leg.endPoint.coordPoint.longitude);
      coord.push(leg.endPoint.coordPoint.latitude);
      toRet.push(coord);
    }
    return toRet;
  }

  getMaxFromDataSet(dataSets: any, isVerticalProfile?: boolean ){
    let max = 0;
    for(let dataSet of dataSets){
      for(let pointIndex in dataSet.data){
        if (isVerticalProfile){
          if(dataSet.data[pointIndex].y > max){
            max = dataSet.data[pointIndex].y;
          }
        } else{
          if(dataSet.data[pointIndex] > max){
            max = dataSet.data[pointIndex];
          }
        }

      }
    }
    return max;
  }

  getMaxFromDistance(distance: any[]){
    let max = 0;
    for(let pointIndex in distance){
      if(distance[pointIndex] > max){
        max = distance[pointIndex];
      }
    }
    return max;
  }
  getWayPointDataSet(wayPointDistances:number[],points:WaypointsDTOCalculation[],
        ymax: any, isBarChart?: boolean, barChartYmin?: string){
    let dataSet = []
    for(let pointIndex = 0, distanceIndex = 0; pointIndex  < points.length; pointIndex++ ){
      if(!points[pointIndex].fixpoint){
        dataSet.push({x: wayPointDistances[distanceIndex],y: ymax, wayPointId: points[pointIndex].identification});
        if (isBarChart){
          dataSet.push({x: wayPointDistances[distanceIndex], y: barChartYmin, wayPointId: points[pointIndex].identification});
        } else {
          dataSet.push({x: wayPointDistances[distanceIndex], y: 0, wayPointId: points[pointIndex].identification});
        }
        dataSet.push({x:NaN,y:NaN}) // separator
        distanceIndex++;
      }
    }
    return {label: 'wayPoints',
      type: 'line',
      data:dataSet,
      fill:false,
      borderColor:'rgba(0, 0, 0)',
      borderWidth: 1,
      tension: 0.1,
      pointBorderWidth:0,
      borderDash:[5,10],
      pointRadius:0,
      backgroundColor: 'rgba(0, 0, 0)',
    } as any;

  }
  showVerticalProfileChart(
    data: any,
    performanceDTO : PerformanceAnalysisDTO
  ) {
    let name = performanceDTO.name;
    this.procedureCalculationType = performanceDTO.performanceType;

    performanceDTO.procedure.waypoints = performanceDTO.procedure.waypoints.filter( waypoint => !waypoint.fixpoint);

    this.displayCalculation = DisplayCalculationInfo.getVerticalProfileDisplay();
    this.displayCalculation.displayLeftColumnInfomation = false;
    let horizontalUnits : string = this.configurationService.currentConfiguration.display.horizontalUnits;
    this.procedureAnalysisResultActive = true;
    let distances: any = []
    let procedureLabels: any = [];
    let procedureData: any = [];
    data.procedureVerticalProfile.data.forEach(item => {
      if(horizontalUnits != 'm'){
        item.distance = this.mapService.convertMetersToNauticalMiles(item.distance);
      }
      procedureLabels.push(item.distance);
      procedureData.push({x:item.distance,y: item.min} );
      distances.push(item.distance);
    });

    const dataAux = {
      labels: procedureLabels,
      datasets: [{
        label: 'Procedure',
        data: procedureData,
        fill: false,
        borderColor: 'rgb(75, 192, 192)',
        borderDash: [0 , 0],
        tension: 0,
        borderWidth:2,
        pointBorderWidth:0,
        pointRadius:0
      }]
    };
    data.navAidsVerticalProfiles.forEach(navaid => {
      let line = []
      let color: Number[] = [];
      for(let i  = 0; i < 3; i++){
        color[i] =Math.round( Math.random()*255);
      }
      let lineColor = `rgb(${color[0]},${color[1]},${color[2]})`;
      if(horizontalUnits != 'm'){
        for(let i = 0; i < navaid.data.length; i++){
          navaid.data[i].distance = this.mapService.convertMetersToNauticalMiles(navaid.data[i].distance);
        }
      }


      if(navaid.in30SecZoneOnly){
        for(let i = 0; i < navaid.data.length; i++){
            line.push({x: navaid.data[i].distance, y: navaid.data[i].min});
            if(navaid.data[i].infoType == 'OUT_30_SEC_ZONE'){
              line.push({x: 0,y: NaN});
            }
        }
        dataAux.datasets.push({
          label: navaid.id + "(30 SEC)",
          data: line,
          borderDash: [10 , 5],
          borderColor: lineColor,
          fill: false,
          tension: 0,
          borderWidth:2,
          pointBorderWidth:0,
          pointRadius:0
        });
      }
      else{
        line = this.getNavaidChartData(navaid.data,distances);
        dataAux.datasets.push({
          label: navaid.id,
          data: line,
          borderColor: lineColor,
          fill: false,
          tension: 0,
          borderDash: [0 , 0],
          borderWidth:2,
          pointBorderWidth:0,
          pointRadius:0
        });
      }
    });



    this.canvas_chart1 = document.getElementById('chart1') as HTMLCanvasElement;
    this.ctx = this.canvas_chart1.getContext('2d');


    if(this.chart1 != undefined){
      this.chart1.destroy();
    }
    // var selectedProcedure = this.pointsService.getAllProceduresFeaturesFromLayers()
    //               .find((feature) => performanceDTO.procedureModel.procedureid == feature.get('procedureid'))
    var procedureLegs = performanceDTO.procedureModel.procedureLegs;
    var procedureCoordinates = this.getProcedureCoordinates(procedureLegs);
    var rootPointsDistance = this.getLegsDistance(procedureLegs);


    Interaction.modes.myCustomModeVerticalProfile = function(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const items = [];
      var drawCounter = 0;
      Interaction.evaluateInteractionItems(chart, 'x', position, (element, datasetIndex, index) => {
        let dataX = chart.scales.x.getValueForPixel(position.x);
        if (dataX >= 0 && drawCounter < 1 && items.length < 1){
          this.pointsService.procedureGraphLayer.childLayers?.forEach(el => {
            el.layers.forEach(layer => {
              layer.olLayer.getSource().clear();
            })
          });
          if (horizontalUnits != 'm'){
            dataX = dataX * 1852 // convert to meters;
          }
          let coordinate = this.calculatePositionOnMap(dataX, procedureCoordinates,rootPointsDistance, procedureLegs);
          coordinate = olProj.transform(coordinate, 'EPSG:4326',this.map.getView().getProjection());
          let point = new Feature({
            geometry: new Point(coordinate),
            featureType : FeatureType.ProcedureGraph
          });
          var myStyle = new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({color: 'red'}),
            })
          })
          point.setStyle(myStyle);

          let source = this.pointsService.procedureGraphLayer.childLayers[0].layers
          .find((element) => element.id === 'Procedure_Graph_Layer')
          .olLayer.getSource();

          source.addFeature(point);
          drawCounter++;
          items.push({element, datasetIndex, index});
          // if (element.inXRange(position.x, useFinalPosition)) {

          // }
        }

      });
      return items;
    }.bind(this);


    //variables to use in legend OnClick
    var thisObj = this;
    var legendDisplay: boolean[] = [];
    dataAux.datasets.forEach(dataset => legendDisplay.push(true));
    // variables to draw waypoints vertical lines
    var waypointsData =  [...rootPointsDistance];
    if(horizontalUnits != 'm'){
      for(let i = 0; i < waypointsData.length; i++){
        waypointsData[i] = this.mapService.convertMetersToNauticalMiles(waypointsData[i])
      }
    }
    let max =this.getMaxFromDataSet(dataAux.datasets, true);
    dataAux.datasets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
    this.chart1 = new Chart(this.ctx, {
      type: 'line',
      plugins: this.chartPlugins,
      data: dataAux,
      options: {
        plugins: {
          legend:{
            labels:{
              filter: (legendItem, chartData) => (legendItem.text != "wayPoints")
            },
            onClick: function(e, legendItem) {
              this.chart.data.datasets.pop();
              const legendDataSetIndex = this.chart.data.datasets.findIndex(dataset => dataset.label == legendItem.text);
              let datasetsCopy = cloneDeep(this.chart.data.datasets);
              let numberOfCuts = 0;
              for (let i = 0; i< datasetsCopy.length; i++){
                if (i == legendDataSetIndex){
                  if (legendDisplay[i] == false){
                    legendDisplay[i] = true;
                  } else {
                    legendDisplay[i] = false;
                    datasetsCopy.splice(i - numberOfCuts, 1);
                    numberOfCuts++;
                  }
                } else if (legendDisplay[i] == false){
                  datasetsCopy.splice(i - numberOfCuts, 1);
                  numberOfCuts++;
                }
              }
              max = thisObj.getMaxFromDataSet(datasetsCopy, true);
              this.chart.data.datasets.push(thisObj.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
              Chart.defaults.plugins.legend.onClick.call(this, e, legendItem, this);
              this.chart.update();
            }
          },
          tooltip: {
            enabled: false
            /*displayColors: false,
            // filter: function (toolTipItem)  {
            //     const item:  any = toolTipItem.chart.data.datasets[toolTipItem.datasetIndex].data[toolTipItem.dataIndex];
            //     return toolTipItem.chart.data.datasets[toolTipItem.datasetIndex].label == 'wayPoints' && item.y == 0;
            // },
            callbacks: {
              title : () => null,
              label: function (context) {
                // const item:  any = context.chart.data.datasets[context.datasetIndex].data[context.dataIndex];
                // const label = "Distance: " + item.x;

                return "Distance: " + context.parsed.x;
              }
            }*/
          },
        },
        responsive: true,
        scales: {
          x: {
            type: 'linear', // MANDATORY TO SHOW YOUR POINTS! (THIS IS THE IMPORTANT BIT)
            display: true, // mandatory
            title: {
              display: true,
              text: horizontalUnits == 'm' ? 'Distance [m]' : 'Distance [NM]',
            },
            grid: {
              display: false
           },
            ticks: {
              stepSize:2.5
            },
            max: this.getMaxFromDistance(distances) + 3
          },
          y: { // and your y axis customization as you see fit...
              display: true,
              type: 'linear',
              title: {
                display: true,
                text: 'Altitude [ft]',
              },
              grid: {
                display: false
             }
          },
        },
          interaction: {
            mode: 'myCustomModeVerticalProfile',
            intersect: false
          },
        },
    });

  }
  createSegmentContinuty(result: any, procedure: ProcedureDTOCalculation): void {
    let json = JSON.parse(result);
    let segmentContinuity: SegmentContinuity = new SegmentContinuity();
    segmentContinuity.averageContinuity = json.averageContinuity;
    segmentContinuity.minimumContinuity = json.minimumContinuity;

    let index = 0;
    json.segments.forEach(segment => {
      segmentContinuity.continuity.set(procedure.waypoints[index].identification + " - " + procedure.waypoints[index + 1].identification, segment[Object.keys(segment)[0]]);
      index++;
    });

    this.procedureSegmentContinuity = segmentContinuity;

  }

  createRedundancyPercentages(result: any): void {
    let json = JSON.parse(result);
    this.redundancyPercentage = json.percentageRedundancy;
    this.redundancyPercentageTable2 = json.percentageRedundancy2;
  }

  showGeoJSONDocSectorization(
    data: CalculationModel,
    showMessage: boolean,
    calcName: string,
    id: number
  ) {

    let navaids_info = new Map<string, String[]>();
    let layers = [];
    let i = 0;

    data.results.forEach(result => {
      let navaid: string = JSON.parse(result.result).features[0].properties.NA;
      let elev: string = JSON.parse(result.result).features[0].properties.ELEV;

      if (navaids_info.has(navaid)) {
        if (!navaids_info.get(navaid).includes(elev)) {
          let list: String[] = navaids_info.get(navaid);
          list.push(elev);
          navaids_info.set(navaid, list);
        }
      } else {
        let list: String[] = [];
        list.push(elev)
        navaids_info.set(navaid, list);
      }
    });
    let elevationLegendPos: number = 0;
    data.results.forEach(result => {
      let navaid: string = JSON.parse(result.result).features[0].properties.NA;
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(result.result, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
          dataProjection: 'CRS:84',
        }),
      });

      let list: String[] = navaids_info.get(vectorSource.getFeatures()[0].getProperties().NA);
      let index: number = list.findIndex(x => x === vectorSource.getFeatures()[0].getProperties().ELEV);
      if (vectorSource.getFeatures().length > 0) {
        let elevation = vectorSource.getFeatures()[0].getProperties()['ELEV'];
        if (elevation == '0'){
          return;
        }
        let layerName = elevation;
        let isRedundacy = true;
        vectorSource.forEachFeature(feature => feature.set('elevationLegendPos', elevationLegendPos.toString()));
        if (index == list.length - 1) {
          for (const feat of vectorSource.getFeatures()) {
            const style = function () {
              const zoom = this.map.getView().getZoom();
              let text = elevation + '';
              if (zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT){
                text = "";
              }
              return [
                new Style({
              stroke: new Stroke({
                color: 'rgba(0,0,0)',
              }),
              text: new Text({
                text: text,
                //scale: font_size,
                font: 'bold ' + 13 + 'px Calibri,sans-serif',
                //offsetX: ratioToAdd,
                offsetY: 0,
                overflow: false,
            fill: new Fill({
              color: 'rgba(0,0,0)'
            }),
          }),
                })
              ];
            }.bind(this);
            feat.setStyle(style);
          };
        } else {
          for (const feat of vectorSource.getFeatures()) {
            const style = function () {
              const zoom = this.map.getView().getZoom();
              let text = elevation + '';
              if (zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT){
                text = "";
              }
              return [
                new Style({
              stroke: new Stroke({
                color: 'rgba(15,10,222)',
              }),
              text: new Text({
                text: text,
                //scale: font_size,
                font: 'bold ' + 13 + 'px Calibri,sans-serif',
                //offsetX: ratioToAdd,
                offsetY: 0,
                overflow: false,
            fill: new Fill({
              color: 'rgba(15,10,222)'
            }),
          }),
                })
              ];
            }.bind(this);
            feat.setStyle(style);
          };
        }
        i++;
        var currentTimeInMilliseconds = Date.now(); // unix timestamp in milliseconds

        var appLayer = new VectorLayerDMTR({
          source: vectorSource,
          declutter: true
        });
        appLayer.setVisible(true);

        //this.mapService.getMap('map').addLayer(appLayer);
        var layerObject = {
          id: layerName + currentTimeInMilliseconds,
          name: layerName,
          image: '',
          visible: isRedundacy,
          expanded: false,
          olLayer: appLayer,
          navaidid: navaid
        };
        layers.push(layerObject);
      }
      elevationLegendPos += 9000;
    })

    let topLayer: TopLevelLayers = new TopLevelLayers(
      true,
      calcName,
      layers,
      this.mapService.getMap('map'),
      this.modalConfirmation,
      this,
      null,
      id
    );
    topLayer.type = "DocAndSectorizationDisplay";
    for (const list of navaids_info.values()){
      if (list[0] == '0'){
        list.splice(0,1);
      }
    }
    topLayer.navaids_info = navaids_info;

    this
      .getCalculationsLayer()
      .childLayers.push(topLayer);
      //this.userSettingsService.createCalculationSettings(id,0.7,)
      if (showMessage) {
        this.storeVisibilityCalculationInUserSettings(topLayer);
        this.modalService.showMesssageModal(
          'Calculation successful',
          'The Doc and Sectorization calculation was successful.'
        );
    }

  }

  orderProcedureByDistance() {
    this.procedurePerformanceLines.sort((a, b) => {
      if (a.distance < b.distance) return -1;
      else if (a.distance > b.distance) return 1;
      else return 0;
    });
  }

  fillProcedureLines(calcID: number) {
    this.procedurePerformanceFeatures.get(calcID).forEach((element) => {
      let currentLine = new ProcedurePerformanceLine();
      currentLine.centerValue = element.get('LINE_CENTER_VALUE');
      currentLine.centerNseValue = element.get('LINE_CENTER_NSE_VALUE');
      currentLine.id = element.get('LINE_NUMBER');
      currentLine.worstValue = element.get('LINE_WORST_VALUE');
      currentLine.worstNseValue = element.get('LINE_NSE_WORST_VALUE');
      currentLine.receiverDelay = element.get('LINE_SIGNAL_DELAY');
      currentLine.centerLatitude = element.get('LINE_CENTER_LATITUDE');
      currentLine.centerLongitude = element.get('LINE_CENTER_LONGITUDE');
      currentLine.centerHeigth = element.get('LINE_CENTER_HEIGHT');
      currentLine.distance = this.mapService.convertMetersToNauticalMiles(
        element.get('DISTANCE')
      );

      if (!this.findInLines(currentLine.id)) {
        this.procedurePerformanceLines.push(currentLine);
      }

    });
    this.orderProcedureByDistance();
  }

  findInLines(id: number) {
    for (
      let index = 0;
      index < this.procedurePerformanceLines.length;
      index++
    ) {
      const element = this.procedurePerformanceLines[index];
      if (element.id == id) {
        return true;
      }
    }
  }



  public showBarChart(calcID: number) {
    this.procedureAnalysisResultActive = true;
    this.updateChart(calcID);
  }


  getDatasets(calcID: number, performance_type?: number): any {
    let horizontalUnits : string = this.configurationService.currentConfiguration.display.horizontalUnits;
    this.procedurePerformanceLines = [];
    this.fillProcedureLines(calcID);
    let toRet = [];
    for (
      let index = 0;
      index < this.procedurePerformanceLines.length;
      index++
    ) {
      const currentLine = this.procedurePerformanceLines[index];
      var e;
      if (performance_type == 1) {
        if (horizontalUnits == 'm') {
          currentLine.distance = Math.round(currentLine.distance * 1852);
        }
        if (index == 0) {
          e = {
            label: 'Distance',
            data: [this.procedurePerformanceLines[index + 1].distance,this.procedurePerformanceLines[index + 1].distance, this.procedurePerformanceLines[index + 1].distance],
            backgroundColor: this.getRedundancyColorFromValue(currentLine),
            borderWidth: 0,
            stack: '1',
            borderSkipped: true,
            hoverBorderWidth: 0,
            hoverBackgroundColor: this.getRedundancyColorFromValue(currentLine),
            hoverBorderColor: this.getRedundancyColorFromValue(currentLine),
            currentline: currentLine
          };
        }else {
          if (this.procedurePerformanceLines[index + 1] != null){
            e = {
              label: 'Distance',
              data: [this.procedurePerformanceLines[index + 1].distance - currentLine.distance,this.procedurePerformanceLines[index + 1].distance - currentLine.distance, this.procedurePerformanceLines[index + 1].distance - currentLine.distance],
              backgroundColor: this.getRedundancyColorFromValue(currentLine),
              borderWidth: 0,
              stack: '1',
              borderSkipped: true,
              hoverBorderWidth: 0,
              hoverBackgroundColor: this.getRedundancyColorFromValue(currentLine),
              hoverBorderColor: this.getRedundancyColorFromValue(currentLine),
              currentline: currentLine
            };
          }
      }

      } else {
        if (index == 0) {
          e = {
            label: 'Distance',
            data: [this.procedurePerformanceLines[index + 1].distance,this.procedurePerformanceLines[index + 1].distance, this.procedurePerformanceLines[index + 1].distance],
            backgroundColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            borderWidth: 0,
            stack: '1',
            borderSkipped: true,
            hoverBorderWidth: 0,
            hoverBackgroundColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            hoverBorderColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            currentline: currentLine
          };
        }else if (this.procedurePerformanceLines[index + 1] != null){
          e = {
            label: 'Distance',
            data: [this.procedurePerformanceLines[index + 1].distance - currentLine.distance,this.procedurePerformanceLines[index + 1].distance - currentLine.distance, this.procedurePerformanceLines[index + 1].distance - currentLine.distance],
            backgroundColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            borderWidth: 0,
            stack: '1',
            borderSkipped: true,
            hoverBorderWidth: 0,
            hoverBackgroundColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            hoverBorderColor: performance_type == 0 ? this.getSubtendedColorFromValue(currentLine) : this.getNSEColorFromValue(currentLine),
            currentline: currentLine
          };
      }
    }

      toRet.push(e);
    }

    return toRet;
  }

  getRedundancyColorFromValue(currentLine: ProcedurePerformanceLine) {
    let toRet = [];
    toRet.push(this.colorMap.get('Redundancy')[currentLine.receiverDelay]?.getColor());
    toRet.push(this.colorMap.get('Redundancy')[currentLine.worstValue]?.getColor());
    toRet.push(this.colorMap.get('Redundancy')[currentLine.centerValue]?.getColor());
    return toRet;
  }

  getNSEColorFromValue(currentLine: ProcedurePerformanceLine) {
    let toRet = [];
    toRet.push(this.colorMap.get('NSE')[currentLine.worstValue]?.getColor());
    toRet.push(this.colorMap.get('NSE')[currentLine.centerValue]?.getColor());
    return toRet;
  }

  getSubtendedColorFromValue(currentLine: ProcedurePerformanceLine) {
    let toRet = [];
    toRet.push(this.colorMap.get('Subtended Angles')[currentLine.worstValue]?.getColor());
    toRet.push(this.colorMap.get('Subtended Angles')[currentLine.centerValue]?.getColor());
    return toRet;
  }

  createInertialPlotCharts(dataset : number[][], worstInertial : boolean){
      const nocoverageLine = (ctx, coverage_values) => {
        let toReturn = null;
        coverage_values.forEach(range => {
          let initial_value = range[0];
          let last_value = range[ range.length - 1];

          if(ctx.p1.parsed.x >= initial_value && ctx.p1.parsed.x <= last_value){
            if(ctx.p0.parsed.x >= initial_value && ctx.p0.parsed.x <= last_value){
              toReturn = 'rgb(0,255,0)';
            }else if(ctx.p0.parsed.y > ProcedurePerformanceInertialDrift.getMaxNSE()){
              toReturn = 'red';
            }
          }
        });
        if(!toReturn) {
          if(ctx.p1.parsed.y > ProcedurePerformanceInertialDrift.getMaxNSE()){
            return 'red';
          }else {
            return 'rgb(15,10,222)';
          }

        }else {
          return toReturn;
        }
    }

    let labels : number[] = [];
    let dataItems : number[] = [];

    var dataset = dataset.sort(function(a, b) {
      return a[0] - b[0];
    });

    dataset.forEach( item => {
      labels.push(item[0]);
      dataItems.push(item[1]);
    });

    let coverage_values : any = ProcedurePerformanceInertialDrift.getCoverageValues();
    let inertial_values : any = ProcedurePerformanceInertialDrift.getInertialValues();
    let backgroundPointColors : any = [];

    for( let i=0; i < labels.length; i++){
      let found = false;
      coverage_values.forEach(range => {
        let initial_value = range[0];
        let last_value = range[ range.length - 1];

        if(labels[i] >= initial_value && labels[i] <= last_value){
          backgroundPointColors.push('rgb(0,255,0)');
          found = true;
          return;
        }
      });
      if(!found){
        if(dataItems[i] > ProcedurePerformanceInertialDrift.getMaxNSE()){
          backgroundPointColors.push('rgb(255,0,0)');
        }else {
          backgroundPointColors.push('rgb(15,10,222)');
        }
      }
    }
    if(worstInertial){
      this.canvas_chart1 = document.getElementById('chartWorstNSEIntertial') as HTMLCanvasElement;
      if(this.canvas_chart1 != null){
        this.ctx = this.canvas_chart1.getContext('2d');
      const data = {
        labels: labels,
        datasets: [{
          label: 'Worst NSE + Inertial',
          data: dataItems,
          backgroundColor: [
            'rgba(0, 255, 0, 1)'
          ],
          pointBackgroundColor : backgroundPointColors,
          pointBorderColor : backgroundPointColors,
          borderColor: [
            'rgba(0, 255, 0, 1)'],
          tension: 0,
          borderWidth: 1,
          segment: {
            borderColor: ctx => nocoverageLine(ctx, coverage_values)
          },
        }]

      };

      this.chartWorstInertial?.destroy();
      this.chartWorstInertial = new Chart(this.ctx, {
        type: 'line',
        data: data,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Worst NSE + Inertial'
            },
            legend: {
              display : false
            },
            tooltip: {
              enabled: true
            },
          },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },
          responsive: true,
          scales: {
            x: {
              type: 'linear',
              display: true,
              title: {
                display: true,
                text: 'Distance [m]',
              },
              grid: {
                display: false
             },
              ticks: {
                stepSize:2.5
              },
            },
            y: { // and your y axis customization as you see fit...
                display: true,
                type: 'linear',
                title: {
                  display: true,
                  text: 'Altitude [ft]',
                },
                grid: {
                  display: false
               }
            },
          },
          },
      });
      }
    }
    else{
      this.chartCenterInertial?.destroy();
      this.canvas_chart2 = document.getElementById('chartCenterNSEIntertial') as HTMLCanvasElement;
      if(this.canvas_chart2 != null){
        this.ctx = this.canvas_chart2.getContext('2d');
      const data = {
        labels: labels,
        datasets: [
          {
            label: 'Center NSE + Inertial',
            data: dataItems,
            backgroundColor: [
              'rgba(0, 255, 0, 1)'
            ],
            pointBackgroundColor : backgroundPointColors,
            pointBorderColor : backgroundPointColors,
            borderColor: [
              'rgba(0, 255, 0, 1)'],
            tension: 0,
            borderWidth: 1,
            segment: {
              borderColor: ctx => nocoverageLine(ctx, coverage_values)
            },
          }
        ]
      };

      this.chartCenterInertial = new Chart(this.ctx, {
        type: 'line',
        data: data,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Center NSE + Inertial'
            },
            legend: {
              display : false
            },
            tooltip: {
              enabled: true
            },
          },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },
          responsive: true,
          scales: {
            x: {
              type: 'linear',
              display: true,
              title: {
                display: true,
                text: 'Distance [m]',
              },
              grid: {
                display: false
             },
              ticks: {
                stepSize:2.5
              },
            },
            y: { // and your y axis customization as you see fit...
                display: true,
                type: 'linear',
                title: {
                  display: true,
                  text: 'Altitude [ft]',
                },
                grid: {
                  display: false
               }
            },
          },
          },
      });
      }
    }
  }
  createPlotChart(calcID: number, performanceDTO: PerformanceAnalysisDTO) {
    let horizontalUnits : string = this.configurationService.currentConfiguration.display.horizontalUnits;
    this.canvas_chart1 = document.getElementById('chart1') as HTMLCanvasElement;
    this.canvas_chart2 = document.getElementById('chart2') as HTMLCanvasElement;

    this.ctx = this.canvas_chart1.getContext('2d');

    const nocoverageLine = (ctx, value) => {
      if(ctx.p0.parsed.y == value && ctx.p1.parsed.y == value){
        return 'rgb(128,128,128)';
      }else if ((ctx.p0.parsed.y == value) && ctx.p0.parsed.y > ctx.p1.parsed.y){
        return 'rgb(0,255,0)';
      } else if ((ctx.p1.parsed.y == value) && ctx.p0.parsed.y < ctx.p1.parsed.y){
        return 'rgb(128,128,128)';
      } else{
        return 'rgb(0,255,0)';
      }
    }
    const nocoveragePoint = (ctx, value) => ctx.parsed.y == value ? 'rgb(128,128,128)' : 'rgb(0,255,0)';

    this.chart1?.destroy();
    this.chart2?.destroy();
    this.procedurePerformanceLines = [];

    let labels = [];
    let dataset_center_value = [];
    let dataset_nse_center_value = [];
    let dataset_worst_value = [];
    let dataset_nse_worst_value = [];
    let dataset_receiver_delay = [];

    this.fillProcedureLines(calcID);

    this.procedurePerformanceLines.forEach(elm => {
      if (!Number.isNaN(elm.distance)) {
        if (horizontalUnits == 'm') {
          elm.distance = Math.round(elm.distance * 1852);
        }
        labels.push(Math.round(elm.distance * 100) / 100);
        dataset_center_value.push(elm.centerValue);
        dataset_worst_value.push(elm.worstValue);
        dataset_receiver_delay.push(elm.receiverDelay);
        if (elm.centerNseValue == 999) {
          dataset_nse_center_value.push(8);
        }else {
          dataset_nse_center_value.push(elm.centerNseValue);
        }

        dataset_nse_worst_value.push(elm.worstNseValue);
      }

    })

    /*var selectedProcedure = this.pointsService.getAllProceduresFeaturesFromLayers()
                .find((feature) => performanceDTO.procedureModel.procedureid == feature.get("procedureid"))*/
    var procedureLegs = performanceDTO.procedureModel.procedureLegs;
    var procedureCoordinates = this.getProcedureCoordinates(procedureLegs);
    var rootPointsDistance = this.getLegsDistance(procedureLegs);



    Interaction.modes.myCustomModeCreatePlotChart = function(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const items = [];
      var drawCounter = 0;
      Interaction.evaluateInteractionItems(chart, 'x', position, (element, datasetIndex, index) => {
        let dataX = chart.scales.x.getValueForPixel(position.x);
        if (dataX >= 0 && drawCounter < 1){
          this.pointsService.procedureGraphLayer.childLayers?.forEach(el => {
            el.layers.forEach(layer => {
              layer.olLayer.getSource().clear();
            })
          });
          if (horizontalUnits != 'm') {
            dataX = dataX * 1852 // convert to meters;
          }

          let coordinate = this.calculatePositionOnMap(dataX, procedureCoordinates,rootPointsDistance, procedureLegs);
          coordinate = olProj.transform(coordinate, 'EPSG:4326',this.map.getView().getProjection());
          let point = new Feature({
            geometry: new Point(coordinate),
            featureType : FeatureType.ProcedureGraph
          });
          var myStyle = new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({color: 'red'}),
            })
          })
          point.setStyle(myStyle);

          let source = this.pointsService.procedureGraphLayer.childLayers[0].layers
          .find((element) => element.id === 'Procedure_Graph_Layer')
          .olLayer.getSource();

          source.addFeature(point);
          drawCounter++;
        }
        if (element.inXRange(position.x, useFinalPosition)) {
          items.push({element, datasetIndex, index});
        }

      });
      return items;
    }.bind(this);

    const data = {
      labels: labels,
      datasets: [{
        label: 'Center Value',
        data: performanceDTO.performanceType != 2 ? dataset_center_value : dataset_nse_center_value,
        backgroundColor: [
          'rgba(255, 99, 132, 1)'
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)'],
        tension: 0,
        borderWidth: 1,
        pointBorderWidth:0,
        pointRadius:0
      },
      {
        label: 'Worst Value',
        data: performanceDTO.performanceType != 2 ? dataset_worst_value : dataset_nse_worst_value,
        backgroundColor: 'rgba(0, 0, 255, 1)',
        borderColor: 'rgba(0, 0, 255, 1)',
        tension: 0,
        borderWidth: 1,
        pointBorderWidth:0,
        pointRadius:0
      }
      ]
    };


    if (performanceDTO.performanceType == 1) {
      data.datasets.push({
        label: 'Receiver Delay',
        data: dataset_receiver_delay,
        backgroundColor: [
          'rgba(0, 255, 0, 1)'
        ],
        borderColor: [
          'rgba(0, 255, 0, 1)'],
        tension: 0,
        borderWidth: 1,
        pointBorderWidth:0,
        pointRadius:0
      });
    }
    //variables to use in legend OnClick
    var thisObj = this;
    var legendDisplay: boolean[] = [];
    data.datasets.forEach(dataset => legendDisplay.push(true));
    // variables to draw waypoints vertical lines
    var waypointsData =  [...rootPointsDistance];
    if(horizontalUnits != 'm'){
      for(let i = 0; i < waypointsData.length; i++){
        waypointsData[i] = this.mapService.convertMetersToNauticalMiles(waypointsData[i])
      }
    }
    let max =this.getMaxFromDataSet(data.datasets);
    data.datasets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));


    if (performanceDTO.performanceType == 1) {
      this.chart1 = new Chart(this.ctx, {
        type: 'line',
        data,
        plugins: this.chartPlugins,
        options: {
          plugins: {
            legend:{
              labels:{
                filter: (legendItem, chartData) => (legendItem.text != "wayPoints")
              },
              onClick: function(e, legendItem) {
                this.chart.data.datasets.pop();
                const legendDataSetIndex = this.chart.data.datasets.findIndex(dataset => dataset.label == legendItem.text);
                let datasetsCopy = cloneDeep(this.chart.data.datasets);
                let numberOfCuts = 0;
                for (let i = 0; i< datasetsCopy.length; i++){
                  if (i == legendDataSetIndex){
                    if (legendDisplay[i] == false){
                      legendDisplay[i] = true;
                    } else {
                      legendDisplay[i] = false;
                      datasetsCopy.splice(i - numberOfCuts, 1);
                      numberOfCuts++;
                    }
                  } else if (legendDisplay[i] == false){
                    datasetsCopy.splice(i - numberOfCuts, 1);
                    numberOfCuts++;
                  }
                }
                max = thisObj.getMaxFromDataSet(datasetsCopy);
                this.chart.data.datasets.push(thisObj.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
                Chart.defaults.plugins.legend.onClick.call(this, e, legendItem, this);
                this.chart.update();
              }
            },
            title: {
              display: true,
              text: 'Redundancy'
          },
            tooltip: {
              callbacks: {
                title: function(context) {
                  console.log(context);
                  return null;
                },
                // TODO: IMPROVE TOOLTIP
                label: function (context) {
                  if (context.dataset.label != "wayPoints"){
                    return "Distance=" + context.label + "; " + context.dataset.label + "= " + context.dataset.data[context.dataIndex];
                  }
                  return;
                }
              }
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                maxTicksLimit: 5,
                callback: function (val) {
                  switch (val) {
                    case 0:
                      return "No Coverage";
                    case 1:
                      return "No Redundancy";
                    case 2:
                      return "Limited Redundancy";
                    case 3:
                      return "Full Redundancy";
                    case 4:
                      return "High Redundancy";
                  }
                },
              }
            },
            x: {
              type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'Distance [m]' : 'Distance [NM]',
              },
              max: thisObj.getMaxFromDistance(labels) + 2.5
              // ticks: {
              //   stepSize: 5
              // }
            }
        },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },

        },
      });

    } else if (performanceDTO.performanceType == 0) {
      this.chart1 = new Chart(this.ctx, {
        type: 'line',
        data,
        plugins: this.chartPlugins,
        options: {
          plugins: {
            legend:{
              labels:{
                filter: (legendItem, chartData) => (legendItem.text != "wayPoints")
              },
              onClick: function(e, legendItem) {
                this.chart.data.datasets.pop();
                const legendDataSetIndex = this.chart.data.datasets.findIndex(dataset => dataset.label == legendItem.text);
                let datasetsCopy = cloneDeep(this.chart.data.datasets);
                let numberOfCuts = 0;
                for (let i = 0; i< datasetsCopy.length; i++){
                  if (i == legendDataSetIndex){
                    if (legendDisplay[i] == false){
                      legendDisplay[i] = true;
                    } else {
                      legendDisplay[i] = false;
                      datasetsCopy.splice(i - numberOfCuts, 1);
                      numberOfCuts++;
                    }
                  } else if (legendDisplay[i] == false){
                    datasetsCopy.splice(i - numberOfCuts, 1);
                    numberOfCuts++;
                  }
                }
                max = thisObj.getMaxFromDataSet(datasetsCopy);
                this.chart.data.datasets.push(thisObj.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
                Chart.defaults.plugins.legend.onClick.call(this, e, legendItem, this);
                this.chart.update();
              }
            },
            title: {
              display: true,
              text: 'Subtended Angle'
          },
          tooltip: {
            callbacks: {
              title: function(context) {return null;},
              label: function (context) {
                if (context.dataset.label != "wayPoints"){
                  return "Distance=" + context.label + "; " + context.dataset.label + "= " + context.dataset.data[context.dataIndex];
                }
                return;
              }
            }
          },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                maxTicksLimit: 10,
                callback: function (val) {
                  switch (val) {
                    case 0:
                      return "0 - 30";
                    case 1:
                      return "30 - 40";
                    case 2:
                      return "40 - 50";
                    case 3:
                      return "50 - 60";
                    case 4:
                      return "60 - 70";
                    case 5:
                      return "70 - 80";
                    case 6:
                      return "80 - 90";
                  }
                },
              }
            },
            x: {
              type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'Distance [m]' : 'Distance [NM]',
              },
               ticks: {
                 stepSize: 2.5
               },
               max: thisObj.getMaxFromDistance(labels) + 2.5
            }
        },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },
        },
      });
    } else {
      let dataSets = [{
        label: 'Worst Value',
        data: dataset_nse_worst_value,
        backgroundColor: [
          'rgba(0, 255, 0, 1)'
        ],
        pointBackgroundColor : ((ctx) => { return nocoveragePoint(ctx, 8) }),
        pointBorderColor : ((ctx) => { return nocoveragePoint(ctx, 8) }),
        borderColor: [
          'rgba(0, 255, 0, 1)'],
        tension: 0,
        borderWidth: 1,
        segment: {
          borderColor: ctx => nocoverageLine(ctx, 8)
        },
      }];
      // variables to draw waypoints vertical lines
      let max =this.getMaxFromDataSet(dataSets);
      dataSets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
      this.chart1 = new Chart(this.ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: dataSets
        },
        plugins: this.chartPlugins,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Worst NSE'
          },
          tooltip: {
            callbacks: {
              title: function(context) {return null;},
              label: function (context) {
                if (context.dataset.label != "wayPoints"){
                  let convertToNumber : number = +context.dataset.data[context.dataIndex];
                  let convertedString : string = convertToNumber != 8? convertToNumber.toFixed(3) : '8';
                  return "Distance=" + context.label + "; " + context.dataset.label + "= " + convertedString;
                }
                return;
              }
            }
          },
            legend: {
              display : false
            }
          },
          scales: {
            y: {
              ticks: {
                stepSize: 0.5
              },
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'NSE [M]' : 'NSE [NM]',
              },
            },
            x: {
              type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'Distance [m]' : 'Distance [NM]',
              },
              ticks: {
                stepSize: 5
              },
              max: this.getMaxFromDistance(labels) + 2.5
            }
        },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },
        },
      });
      this.ctx = this.canvas_chart2.getContext('2d');
      dataSets = [{
        label: 'Center Value',
        data: dataset_nse_center_value,
        backgroundColor: [
          'rgba(0, 255, 0, 1)'
        ],
        borderColor: [
          'rgba(0, 255, 0, 1)'],
        pointBackgroundColor : ((ctx) => { return nocoveragePoint(ctx, 8) }),
        pointBorderColor : ((ctx) => { return nocoveragePoint(ctx, 8) }),
        tension: 0,
        borderWidth: 1,
        segment: {
          borderColor: ctx => nocoverageLine(ctx, 8)
        },
      }];
      max =this.getMaxFromDataSet(dataSets);
      dataSets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max));
      this.chart2 = new Chart(this.ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: dataSets
        },
        plugins: this.chartPlugins,
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Center NSE'
            },
            legend: {
              display : false
            },
            tooltip: {
              callbacks: {
                title: function(context) {return null;},
                label: function (context) {
                  if (context.dataset.label != "wayPoints"){
                    let convertToNumber : number = +context.dataset.data[context.dataIndex];
                    let convertedString : string = convertToNumber != 8? convertToNumber.toFixed(3) : '8';
                    return "Distance=" + context.label + "; " + context.dataset.label + "= " + convertedString;
                  }
                  return;
                }
              }
            },
          },
          scales: {
            y: {
              ticks: {
                stepSize: 0.5
              },
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'NSE [M]' : 'NSE [NM]',
              },
            },
            x: {
              type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm' ? 'Distance [m]' : 'Distance [NM]',
              },
              ticks: {
                stepSize: 5
              },
              max: this.getMaxFromDistance(labels) + 2.5
            }
        },
          interaction: {
            mode: 'myCustomModeCreatePlotChart',
            intersect: false
          },
        },
      });
    }

  }



  updateChart(calcID: number, performanceDTO?: PerformanceAnalysisDTO) {
    let horizontalUnits : string = this.configurationService.currentConfiguration.display.horizontalUnits;
    this.canvas_chart1 = document.getElementById('chart1') as HTMLCanvasElement;
    this.ctx = this.canvas_chart1.getContext('2d');
    this.chart1?.destroy();
    this.chart2?.destroy();

   /* var selectedProcedure = this.pointsService.getAllProceduresFeaturesFromLayers()
                            .find((feature) => performanceDTO.procedureModel.procedureid == feature.get('procedureid'))*/
    var procedureLegs = performanceDTO.procedureModel.procedureLegs;
    var procedureCoordinates = this.getProcedureCoordinates(procedureLegs);
    var rootPointsDistance = this.getLegsDistance(procedureLegs);
    Interaction.modes.myCustomModeCreateBarChart = function(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const items = [];
      var drawCounter = 0;
      Interaction.evaluateInteractionItems(chart, 'x', position, (element, datasetIndex, index) => {
        let dataX = chart.scales.x.getValueForPixel(position.x);
        if (dataX >= 0 && drawCounter < 1){
          this.pointsService.procedureGraphLayer.childLayers?.forEach(el => {
            el.layers.forEach(layer => {
              layer.olLayer.getSource().clear();
            })
          });

          if(horizontalUnits != 'm') {
            dataX = dataX * 1852; // convert to meters;
          }

          let coordinate = this.calculatePositionOnMap(dataX, procedureCoordinates,rootPointsDistance, procedureLegs);
          coordinate = olProj.transform(coordinate, 'EPSG:4326',this.map.getView().getProjection());
          let point = new Feature({
            geometry: new Point(coordinate),
            featureType : FeatureType.ProcedureGraph
          });
          var myStyle = new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({color: 'red'}),
            })
          })
          point.setStyle(myStyle);

          let source = this.pointsService.procedureGraphLayer.childLayers[0].layers
          .find((element) => element.id === 'Procedure_Graph_Layer')
          .olLayer.getSource();

          source.addFeature(point);
          drawCounter++;
        }
        if (element.inXRange(position.x, useFinalPosition)) {
          items.push({element, datasetIndex, index});
        }

      });
      return items;
    }.bind(this);

    var waypointsData =  [...rootPointsDistance];
    if(horizontalUnits != 'm'){
      for(let i = 0; i < waypointsData.length; i++){
        waypointsData[i] = this.mapService.convertMetersToNauticalMiles(waypointsData[i])
      }
    }


    if (performanceDTO.performanceType == 1) {
      let labels = ['Receiver Delay', 'Worst Value', 'Center Value'];
      let dataSets = this.getDatasets(calcID, performanceDTO.performanceType)
      let max = labels[labels.length-1];
      dataSets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max, true, labels[0]));
      this.chart1 = new Chart(this.ctx, {
        type: 'bar',
        data: {
          labels: labels ,
          datasets: dataSets,
        },
        plugins: this.chartPlugins,
        options: {
          indexAxis: 'y',
          plugins: {
            title: {
              display: true,
              text: 'Redundancy'
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled:false
              /*mode: 'point',
              callbacks: {
                // TODO: IMPROVE TOOLTIP
                label: function (context) {
                  var label = '';

                  if(context.dataIndex == 0) {
                    label += 'Value: ' + context.dataset?.currentline.receiverDelay;
                  } else if (context.dataIndex == 1) {
                    label += 'Value: ' + context.dataset?.currentline.worstValue;
                  }else {
                    label += 'Value: ' + context.dataset?.currentline.centerValue;
                  }
                  return label;
                }
              }*/

            }
          },
          responsive: true,
          scales: {
            y: {
              stacked: true
            },
            x:
            {
              type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm'? 'Distance [m]' : 'Distance [NM]',
              },
              ticks: {
                stepSize: 2.5
              },
              max: this.getMaxFromDistance(waypointsData) + 2.5

            },
        },
          interaction: {
            mode: 'myCustomModeCreateBarChart',
            intersect: false
          },
        },
      });
    } else {
      let labels = ['Worst Value', 'Center Value'];
      let dataSets = this.getDatasets(calcID, performanceDTO.performanceType)
      let max = labels[labels.length-1];
      dataSets.push(this.getWayPointDataSet(waypointsData,performanceDTO.procedure.waypoints,max, true, labels[0]));
      this.chart1 = new Chart(this.ctx, {
        type: 'bar',
        data: {
          labels: ['Worst Value', 'Center Value'],
          datasets: dataSets,
        },
        plugins: this.chartPlugins,
        options: {
          indexAxis: 'y',
          plugins: {
            title: {
              display: true,
              text: performanceDTO.performanceType == 0? 'Subtended Angle' : 'Worst NSE'
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled:false
              /*mode: 'point',
              callbacks: {
                // TODO: IMPROVE TOOLTIP
                label: function (context) {
                  var label = '';

                  if(context.dataIndex == 0) {
                    label += 'Value: ' + context.dataset.currentline.worstNseValue;
                  }else {
                    label += 'Value: ' + context.dataset.currentline.centerNseValue;
                  }

                  return label;
                }
              }*/
            }
          },
          responsive: true,
          scales: {
            y: {
              stacked: true
            },
            x:
            {
                type: 'linear',
              title: {
                display: true,
                text: horizontalUnits == 'm'? 'Distance [m]' : 'Distance [NM]',
              },
              stacked: true,
              ticks: {
                stepSize: 2.5
              },
              max: this.getMaxFromDistance(waypointsData) + 2.5
            },
          },
          interaction: {
            mode: 'myCustomModeCreateBarChart',
            intersect: false
        },
        },
      });
    }

  }

  public reprojectCalculations(projection: string): void {
    this.getPreviousCalculations();
  }


  addLayerByType(layers: any, performance_type: string, vectorSource: VectorSource) {
    let currentTimeInMilliseconds = Date.now();

    let appLayer = new VectorLayerDMTR({
      source: vectorSource,
    });
    appLayer.setVisible(true);
    layers.push({
      id: '' + currentTimeInMilliseconds,
      name: performance_type,
      image: '',
      visible: true,
      olLayer: appLayer,
      procedure: true
    });
  }

  getFeatureColor(feat: Feature, value: number, performance_type: string,opacity:number): Style {
    var colorFill = cloneDeep(this.colorMap.get(performance_type)[value]);
    this.utilsService.changeFillTransparency(colorFill,opacity);
    return new Style({
      image: new CircleStyle({
        radius: 3,
        fill: colorFill,
      })
    });

  }
  getCalculationFromMap(calcID: number): TopLevelLayers {
    let calculationOutput: TopLevelLayers;
    for (let calculation of this.calculationsLayers.childLayers) {
      if (calculation.calcID == calcID) {
        calculationOutput = calculation;
      }
    }
    return calculationOutput;
  }

  calculateCrossSection(crossSectionDTO: CrossSectionDTO): Observable<Object> {
    crossSectionDTO.projectId = this.projectController.activeProject.id;
    return this.http
      .post(
        this.endpointsService.crossSectionUrl,
        crossSectionDTO,
        this.endpointsService.httpOptions
      )
  }

  calculateTerrainHeightAtPoint(coordinate: Coordinate) {
    const terrainHeightDTO = new TerrainHeightDTO();
    terrainHeightDTO.coordinate = coordinate;
    terrainHeightDTO.projectId = this.projectController.activeProject.id;
    return this.http
      .post(
        this.endpointsService.terrainHeightUrl,
        terrainHeightDTO,
        this.endpointsService.httpOptions
      );

  }

  async getCalculationById(calcId: number): Promise<CalculationModel>{
    const toReturn: CalculationModel = await this.http.get<CalculationModel>(
      environment.calculation + "/calculation/" + calcId,
      this.endpointsService.httpOptions
    ).toPromise();
    if (toReturn == null){
      this.modalService.showMesssageModal(
        'Calculation',
        'There was an error fetching the calculation.'
      );
    }
    return toReturn;
  }

  async updateCalculation(newCalc :CalculationModel): Promise<boolean> {
    const toReturn: boolean = await this.http.put<boolean>(
      environment.calculation + "/calculation/" + newCalc.id,
      newCalc,
      this.endpointsService.httpOptions
    ).toPromise();
    if (!toReturn){
      this.modalService.showMesssageModal(
        'Update Calculation',
        'There was an error updating the calculation.'
      );
    }
    return toReturn;
  }

  calculateTerrainAltitudeCut(model: TerrainAltitudeCutDTO, showMessage: boolean = true) {
    model.projectId = this.projectController.activeProject.id;this.http
      .post(
        this.endpointsService.altitudeCutUrl,
        model,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.showError(error)
        }
    );
  }

  showGeoJSONTerrainAltitudeCut(data: CalculationModel, showMessage: boolean, calcName: string, id: number) {
    let layers = [];
    let layerName = 'Terrain Altitude Cut';

    data.results.forEach((result) => {

      // Get source
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(result.result, {
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
        format: new GeoJSON({
          featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
          dataProjection: 'CRS:84',
        }),
      });

      if (vectorSource.getFeatures().length > 0) {
        const transparency: number = this.userSettingsService.getCalculationTransparency(id);
        var layerId;
        let elevation;

        vectorSource.getFeatures().forEach((feature) => {

          var fill;
          var stroke;

          layerId= feature.getProperties()['ID'];

          // Set color depends on ELEVARION value
          elevation= feature.getProperties()['ELEVATION'];

          fill = new Fill({
            color: `rgba(255, 0, 0, ${transparency} )`, //4
          })

          stroke = new Stroke({
            color: 'rgba(255, 0, 0, 1)'
          })

          let style = new Style({
            fill: fill,
            stroke: stroke
          });

          feature.setStyle(style);
        });

        var appLayer = new VectorLayerDMTR({
          source: vectorSource,
        });
        appLayer.setVisible(true);

        var layerObject = {
          id: layerId,
          name: layerName + " " + elevation + " feet",
          image: '',
          visible: true,
          expanded: false,
          olLayer: appLayer,
          elevation: elevation,
        };
        layers.push(layerObject);

        let name = (calcName?.length > 0) ? calcName + ": " : "";

        let topLevel: TopLevelLayers = new TopLevelLayers(
          true,
          name + layerName,
          layers,
          this.mapService.getMap('map'),
          this.modalConfirmation,
          this,
          null,
          id
        );
        topLevel.type = "TerrainAltitudeCut";

        this.getCalculationsLayer().childLayers.push(topLevel);

        if (showMessage) {
          this.storePerformanceVisibility(id,layers);
          this.modalService.showMesssageModal(
            'Calculation successful',
            'The Terrain Altitude Cut calculation was successful.'
          );
        }

      } else {
        // No features, show message
        this.modalService.showMesssageModal(
          'Terrain Altitude Cut Results',
          'The performed calculation did not return any result. Please check calculation parameters.'
        );

        this.deleteCalculation(data.id, false);
      }
    }
    );
  }

  async openCalcInfoWindow(calcId: number, calcType: string){
    const calcInfo: CalcConfigInfo = await this.getCalcInfo(calcId);
    if (calcInfo == null){
      this.modalService.showMesssageModal(
        'Error',
        'Unable to open the selected calculation info.'
      );
      return;
    }
    try{
      const parsedInfo = JSON.parse(calcInfo.calcConfig);
      this.calculationInfoIsString = false;
      switch(calcType){
        case "Impact Assessment":
          const calcImpactAssessmentLog: CalcImpactAssessmentLog = new CalcImpactAssessmentLog();
          Object.assign(calcImpactAssessmentLog, parsedInfo);
          this.calcInfo = calcImpactAssessmentLog;
          this.mergeCalculationConfigSectorizations();
          break;

        case "DocAndSectorizationDisplay":
          const calcSecLog: CalcSectorizationLog = new CalcSectorizationLog();
          Object.assign(calcSecLog, parsedInfo);
          this.calcInfo = calcSecLog;
          break;
          case "Coverage":
            const calcCoverageLog: CalcCoverageLog = new CalcCoverageLog();
        Object.assign(calcCoverageLog, parsedInfo);
        this.calcInfo = calcCoverageLog;
        break;
      case "PERFORMANCE":
        const calcPerformanceLog: CalcPerformanceLog = new CalcPerformanceLog();
        Object.assign(calcPerformanceLog, parsedInfo);
        this.calcInfo = calcPerformanceLog;
        break;
      case "PROCEDURE_ANALYSIS":
        const calcProcedurePerfLog: CalcProcedurePerfLog = new CalcProcedurePerfLog();
        Object.assign(calcProcedurePerfLog, parsedInfo);
        this.calcInfo = calcProcedurePerfLog;
        break;
      case "NavaidSitingTool":
        const navLocAssessLog: NavLocAssessLog = new NavLocAssessLog();
        Object.assign(navLocAssessLog, parsedInfo);
        this.calcInfo = navLocAssessLog;
        break;
        case "Cumulative Coverage":
          const cumulativeCoverageLog: CumulativeCoverageLog = new CumulativeCoverageLog();
          Object.assign(cumulativeCoverageLog, parsedInfo);
          this.calcInfo = cumulativeCoverageLog;
          break;
        case "Overlap":
          const calcOverlapLog: CalcCoverageLog = new CalcCoverageLog();
          Object.assign(calcOverlapLog, parsedInfo);
          this.calcInfo = calcOverlapLog;
          break;
        case "TerrainAltitudeCut":
          const terrainAltitudeCutLog: TerrainAltitudeCutLog = new TerrainAltitudeCutLog();
          Object.assign(terrainAltitudeCutLog, parsedInfo);
          this.calcInfo = terrainAltitudeCutLog;
          break;
          default:
            this.modalService.showMesssageModal(
              'Error',
              'Unable to open the selected calculation info.'
              );
              return;
            }
    }
    catch{
      this.calculationInfoIsString = true;
      this.calcInfoString = calcInfo.calcConfig;
      this.calcInfo = new CalcCoverageLog();
    }
    if (!this.configurationService.terrainTypes || this.configurationService.terrainTypes.length == 0){
      await this.configurationService.fetchTerrainTypesPromiseRequest();
    }
    this.calcConfigInfoActive = true;
    this.toolsService.navigationOnTop = true;
  }

  closeCalcInfoWindow(){
    this.calcInfoDTO = undefined;
    this.calcConfigInfoActive = false;
  }

  async getCalcInfo(calcId: number): Promise<CalcConfigInfo>{
    const calcInfo: CalcConfigInfo = new CalcConfigInfo();
    const response: CalcConfigInfo =  await this.http.get<CalcConfigInfo>(
      this.endpointsService.getCalcInfo + '/' + calcId,
      this.endpointsService.httpOptions
    ).toPromise();
    if (response == null){
      return null;
    }
    calcInfo.calcId = response.calcId;
    calcInfo.calcConfig = response.calcConfig;

    return calcInfo;
  }

  private mergeCalculationConfigSectorizations(): void {
    if (this.calcInfo instanceof CalcImpactAssessmentLog) {
      const calcInfo = (this.calcInfo as CalcImpactAssessmentLog);
      if (!calcInfo.calculationImpactAssessmentDTO) {
        return;
      }
      for (const device of calcInfo.calculationImpactAssessmentDTO.devices) {
        if (!device.sectorizations) {
          continue;
        }
        for (let i = 0; i < device.sectorizations.length; i++) {
          const sect = device.sectorizations[i];
          if (sect.isminanglenegative) sect.minangle -= 360;
          if (sect.ismaxanglenegative) sect.maxangle -= 360;
          if (!sect.ishalf) {
            continue;
          }
          const secondHalf = device.sectorizations[i + 1];
          if (secondHalf.ismaxanglenegative) secondHalf.maxangle -= 360;
          sect.maxangle = secondHalf.maxangle;
          device.sectorizations.splice(i + 1, 1);
        }
      }
    }
  }


  public static decompressResult(compressedResult: Uint8Array): string {
    try {
      const inflatedData = pako.inflate(compressedResult, { to: 'string' });
      return inflatedData;
    } catch (error) {
      console.error('Error decompressing data:', error);
      return null;
    }
  }
}
export class Legend{
  label: string;
  color: string;
  constructor(label:string,
    color: string
    ){
      this.label = label;
      this.color = color;
    }
}
